// Defensive initialization - ensure userData is always defined
window.userData = window.userData || {};

function randomString(length) {
  return window.StringUtils.randomString(length);
}

function populateElfStyles() {
  var container = document.getElementById('elf-styles-container');
  if (!container || !window.fixtures || !window.fixtures.hardcoded_json) {
    console.log('Elf styles container or data not found');
    return;
  }

  container.innerHTML = '';

  window.fixtures.hardcoded_json.forEach(function (style) {
    var styleDiv = document.createElement('div');
    styleDiv.className =
      'ai-categories mdl-cell mdl-cell--1-col mdl-cell--stretch';

    styleDiv.innerHTML = `
            <span class="mdl-list__item-primary-content" onclick="return addGenerationCat('${style.title_name}')">
                <span class="avatar-category">
                    <img loading="lazy" class="ai-avatar-icon" src="${style.image_url}" alt="${style.title_name}">
                </span>
                <span class="ai-example center-desc category-capped ai-name mdl-chip__text mdl-chip search-cat-chip">${style.title_name}</span>
            </span>
        `;

    container.appendChild(styleDiv);
  });
}

// Graceful fallback if jQuery sendkeys plugin is unavailable
function safeSendKeys($element, text) {
  try {
    if (window.$ && $.fn && typeof $.fn.sendkeys === 'function') {
      $element.sendkeys(text);
      return;
    }
    const el = $element && $element[0];
    if (!el) return;
    const value = el.value || '';
    const start =
      typeof el.selectionStart === 'number' ? el.selectionStart : value.length;
    const end =
      typeof el.selectionEnd === 'number' ? el.selectionEnd : value.length;
    el.value = value.slice(0, start) + text + value.slice(end);
    const caret = start + text.length;
    if (typeof el.selectionStart === 'number') {
      el.selectionStart = el.selectionEnd = caret;
    }
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  } catch (e) {
    console.error('Error dispatching input/change events:', e);
  }
}
getTagsTemplate = function (tags) {
  if (!tags) {
    return '';
  }
  
  // Handle case where tags might be a comma-separated string instead of array
  var tagArray;
  if (typeof tags === 'string') {
    // Split by comma and trim each tag
    tagArray = tags.split(',').map(function(tag) { 
      return tag.trim(); 
    }).filter(function(tag) { 
      return tag.length > 0; 
    });
  } else if (Array.isArray(tags)) {
    tagArray = tags;
  } else {
    return '';
  }
  
  var tagsTemplate = `
    <div class="mdl-card__supporting-text">
         `;
  for (var i = 0; i < tagArray.length; i++) {
    var currentTag = tagArray[i];
    var urlEncodedTag = encodeURIComponent(currentTag);
    var currentTagDisplay = currentTag;
    if (currentTag.length > 20) {
      currentTagDisplay = currentTag.substring(0, 20) + '...';
    }
    currentTag = currentTag.trim();
    if (currentTag) {
      tagsTemplate += `<div class="mdl-chip">
<span class="mdl-chip__text"><a href="/aiartgenerator?c=${urlEncodedTag}" target="_blank">${currentTag}</a></span></div>`;
    }
  }
  tagsTemplate += `</div>`;
  return tagsTemplate;
};

function getCookie(cookieName) {
  return window.CookieUtils.getCookie(cookieName);
}

window.updateHeaderAuthState = function () {
  const authStatus = isUserAuthenticated();
  const loginElements = document.querySelectorAll('.header-login-signup');
  const logoutElements = document.querySelectorAll('.header-login-signout');
  const accountElements = document.querySelectorAll('.header-account');
  const subscribeElements = document.querySelectorAll('.header-subscribe');

  if (authStatus && authStatus.isAuthenticated) {
    loginElements.forEach((el) => (el.style.display = 'none'));
    logoutElements.forEach((el) => (el.style.display = ''));
    accountElements.forEach((el) => (el.style.display = ''));
    subscribeElements.forEach((el) => (el.style.display = ''));
  } else {
    loginElements.forEach((el) => (el.style.display = ''));
    logoutElements.forEach((el) => (el.style.display = 'none'));
    accountElements.forEach((el) => (el.style.display = 'none'));
    subscribeElements.forEach((el) => (el.style.display = 'none'));
  }
};

function isUserAuthenticated() {
  if (window.userData && window.userData.secret && window.userData.email) {
    return {
      isAuthenticated: true,
      email: window.userData.email,
      source: 'userData',
    };
  } else if (
    window.authSession &&
    window.authSession.isLoggedIn &&
    window.authSession.isLoggedIn()
  ) {
    var currentUser = window.authSession.getCurrentUser();
    return {
      isAuthenticated: true,
      email: currentUser ? currentUser.email : '',
      source: 'authSession',
    };
  } else {
    var userSecret = getCookie('user_secret');
    if (userSecret && window.userData && window.userData.email) {
      return {
        isAuthenticated: true,
        email: window.userData.email,
        source: 'user_secret_cookie',
      };
    }
  }
  return { isAuthenticated: false, email: '', source: 'none' };
}

const setCookie = function (name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }
  document.cookie = name + '=' + value + expires + '; path=/; SameSite=Strict';
};
window.subscribeImageGenCounter = 0;

var subscribeImageGenCounterCookie = +getCookie('subscribeImageGenCounter');
if (subscribeImageGenCounterCookie) {
  window.subscribeImageGenCounter = subscribeImageGenCounterCookie;
}
window.subscribeMessageCounter = 0;
var subscribeMessageCounterCookie = +getCookie('subscribeMessageCounter');
if (subscribeMessageCounterCookie) {
  window.subscribeMessageCounter = subscribeMessageCounterCookie;
}

function appendToChatLog(html) {
  let $chatLog = $('.chat-log');
  var currentHeight = $chatLog.height();
  $chatLog.append(html);
  var newHeight = $chatLog.height();

  var extraHeight = newHeight - currentHeight;
  var currentScrollTop = $('.mdl-layout__content').scrollTop();
  $('.mdl-layout__content').scrollTop(currentScrollTop + extraHeight);
}

var api_base_url = 'https://api.text-generator.io/api/v1/generate';

function sanitizePrompt(prompt) {
  return window.StringUtils.sanitizePrompt(prompt);
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function stripSpeakerLabel(text, speakerName) {
  if (!text) return '';
  if (!speakerName) return text.trim();

  var names = [speakerName];
  var lowerName = speakerName.toLowerCase();
  if (lowerName.indexOf('narrator') !== -1) {
    names.push('Narrator');
  }

  var namePattern = names.map(escapeRegExp).join('|');
  if (!namePattern) return text.trim();

  var boldInside = new RegExp('(^|\\n)\\s*\\*\\*(' + namePattern + '):\\*\\*\\s*', 'i');
  var boldOutside = new RegExp('(^|\\n)\\s*\\*\\*(' + namePattern + ')\\*\\*:\\s*', 'i');
  var plain = new RegExp('(^|\\n)\\s*(' + namePattern + '):\\s*', 'i');

  if (boldInside.test(text)) {
    return text.replace(boldInside, '$1').trim();
  }
  if (boldOutside.test(text)) {
    return text.replace(boldOutside, '$1').trim();
  }
  if (plain.test(text)) {
    return text.replace(plain, '$1').trim();
  }

  return text.trim();
}

function buildPrompt(game) {
  var characterName = fixtures.currentAI?.name;
  var humanName = 'Noo';
  if (window.userData) {
    humanName =
      (window.userData && (window.userData.username || window.userData.name)) ||
      'Noo';
  }

  var prompt = `characters in story chat
desirable lovable hero ${humanName}
${characterName}
${game.backstory}`;

  prompt +=
    `
${characterName} ` + fixtures.currentAI.greeting;

  var istart = Math.min(game.allInputs.length - 3, 0);

  for (var i = istart + 1; i < game.inputOutputPairs.length; i += 2) {
    prompt += `
${humanName} ${game.inputOutputPairs[i - 1]}
${characterName} ${game.inputOutputPairs[i]}`;
  }

  var lastLine = questionsgame.game.allInputs.slice(-1)[0];
  prompt += `
${lastLine}
${characterName} `;
  prompt = sanitizePrompt(prompt) + ' ';

  return prompt;
}

function hasSubscribeText(prediction) {
  return prediction.indexOf('subscrib');
}

function setupSaveGameState(game, inputOutputs) {
  for (var i = 1; i < inputOutputs.length; i += 2) {
    var input = inputOutputs[i - 1];

    input = sanitizePrompt(input);
    var output = inputOutputs[i];
    let userName = 'Noo';
    if (window.userData) {
      userName =
        (window.userData &&
          (window.userData.username || window.userData.name)) ||
        'Noo';
    }

    output = output.replace('{{user}}', userName);
    output = output.replace('[user]', userName);
    output = output.replace('{{ user}}', userName);
    output = output.replace('{{user }}', userName);
    output = output.replace('{{ user }}', userName);
    game.input += `
${userName}: ${input}
${fixtures.currentAI?.name}: ${output}`;
    game.lastGeneratedText = output;

    game.addInputOutputPair(input, output);
  }
}
function rebuildGameState(gameState) {
  let $allMessages = $('.chat-log__message');
  var currentGreeting = $allMessages.first().text();

  var inputMessages = [];
  var outputMessages = [];
  $allMessages.each(function (index, element) {
    var $element = $(element);
    var text = $element.text();
    if ($element.parent().hasClass('chat-log__item--own')) {
      inputMessages.push(text);
    } else {
      outputMessages.push(text);
    }
  });
  outputMessages = outputMessages.slice(1, outputMessages.length);

  var inputOutputs = [];
  for (var i = 0; i < inputMessages.length && i < outputMessages.length; i++) {
    inputOutputs.push(inputMessages[i]);
    inputOutputs.push(outputMessages[i]);
  }

  var saveGame = {
    backstory: currentGreeting,
    input_outputs: inputOutputs,
  };
  gameState.constructStateFromSave(saveGame);
  return saveGame;
}

function reInitGameState(game) {
  game.inputOutputPairs = [];
  game.input = game.originalInput;
}

const hashCode = function (s) {
  return s.split('').reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
};
function shuffle(array, seed) {
  var m = array.length,
    t,
    i;

  while (m) {
    i = Math.floor(random(seed) * m--);

    t = array[m];
    array[m] = array[i];
    array[i] = t;
    ++seed;
  }

  return array;
}

function random(seed) {
  var x = Math.sin(seed++) * 10000;
  return x - Math.floor(x);
}

function generateNewBackground(prediction) {
  var currentAIName = fixtures.currentAI?.name;
  if (!currentAIName) {
    return;
  }

  currentAIName = currentAIName.substring(0, 40);
  var backgroundModifier = '';
  try {
    var backgroundModifiers = [
      'nostalgic colorful relaxing chill realistic cartoon Charcoal illustration fantasy fauvist abstract impressionist watercolor painting Background location scenery amazing wonderful beautiful charming picturesque'.split(
        ' '
      ),
    ];

    var hash = hashCode(prediction);

    var numBackgroundModifiersChosen = (hash % 5) + 1;

    backgroundModifiers = shuffle(backgroundModifiers, hash);
    backgroundModifier = backgroundModifiers[0]
      .slice(0, numBackgroundModifiersChosen)
      .join(' ');
  } catch (e) {
    backgroundModifier =
      'Backdrop location scenery amazing wonderful beautiful charming picturesque';
  }

  var predictionPrompt = sanitizePrompt(prediction);

  predictionPrompt = predictionPrompt.replace(/[^a-zA-Z0-9 ]/g, '');
  var bgPrompt = `${backgroundModifier} ${currentAIName} ${predictionPrompt}`;
  bgPrompt = sanitizePrompt(bgPrompt);
  var bgPromptKey = encodeURIComponent(bgPrompt.replaceAll(' ', '-'));
  dataAccessor.makeAIImage(bgPrompt, bgPromptKey).then(function (response) {
    preloadImage(response.path, function () {
      window.setTimeout(function () {
        setBackground(response.path);
      }, 600);
    });
  });
}

var generateNewBackgroundDebounced = _.debounce(generateNewBackground, 10000);

async function generateArtFromResponse(artPrompt, fullResponse) {
  try {
    console.log('Generating art for response:', artPrompt);

    let cleanPrompt = artPrompt
      .replace(/[^\w\s,.!?-]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    let promptAddition = localStorage.getItem('makeArtPromptAddition');
    if (promptAddition === null) {
      promptAddition = 'anime';
    }
    promptAddition = (promptAddition || '')
      .replace(/[^\w\s,.!?-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (promptAddition) {
      cleanPrompt = `${promptAddition}${cleanPrompt ? ' ' + cleanPrompt : ''}`;
    }

    if (cleanPrompt.length < 20) {
      cleanPrompt = `artistic interpretation of: ${cleanPrompt}`;
    }

    let response;
    const makeArtModel = localStorage.getItem('makeArtModel') || 'default';
    if (makeArtModel === 'gpt-image-2') {
      const secret = window.userData && (window.userData.secret || window.userData.api_key);
      if (!secret || secret === 'anonymous') {
        if (window.showSubscribeDialog) window.showSubscribeDialog();
        return;
      }
      const size = localStorage.getItem('makeArtSize') || '1024x1024';
      const result = await fetch('/api/gpt-image-2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: 'Bearer ' + secret,
        },
        body: JSON.stringify({
          prompt: cleanPrompt,
          size: size,
          quality: 'auto',
          num_images: 1,
          source: 'chat',
        }),
      });
      const decoded = await result.json();
      if (!result.ok || !decoded.success) {
        throw new Error(decoded.error || 'GPT Image 2 generation failed');
      }
      response = { path: decoded.image_url, credits_charged: decoded.credits_charged };
      if (decoded.credits_charged && window.userData && window.userData.credits !== undefined) {
        window.userData.credits -= decoded.credits_charged;
        $('.api-credits-balance-usd').text(parseFloat(window.userData.credits).toFixed(2));
        $('.api-credits-balance').text(window.userData.credits);
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('netwrck_user', JSON.stringify(window.userData));
        }
      }
    } else {
      response = await dataAccessor.makeAIImage(
        cleanPrompt,
        `chat_art_${Date.now()}`,
        512,
        512
      );
    }

    let imageUrl;
    if (response && response.path) {
      imageUrl = response.path;
    } else if (response && response.images && response.images.length > 0) {
      imageUrl = response.images[0].url;
    } else if (
      response &&
      response.result &&
      response.result.images &&
      response.result.images.length > 0
    ) {
      imageUrl = response.result.images[0].url;
    }

    if (imageUrl) {
      const $chatLog = $('.chat-log');
      let wrap = null;
      if (
        window.ChatImageToVideo &&
        typeof window.ChatImageToVideo.appendChatArtImage === 'function'
      ) {
        wrap = window.ChatImageToVideo.appendChatArtImage(
          imageUrl,
          $chatLog[0]
        );
      } else {
        const imgElement = document.createElement('img');
        imgElement.src = imageUrl;
        imgElement.alt = 'Generated art';
        imgElement.style.cssText =
          'max-width: 100%; min-width: 150px; border-radius: 8px; margin-top: 10px;';
        imgElement.loading = 'lazy';
        $chatLog.append(imgElement);
      }

      const extraHeight = (wrap && wrap.offsetHeight) || 200;
      const currentScrollTop = $('.mdl-layout__content').scrollTop();
      $('.mdl-layout__content').scrollTop(currentScrollTop + extraHeight);
    }
  } catch (error) {
    console.error('Error generating art from response:', error);
  }
}

function generateAICharacterPortrait(prompt) {
  var currentAIName = fixtures.currentAI?.name;

  currentAIName = currentAIName.substring(0, 40);

  var backgroundModifier =
    'Backdrop location scenery amazing wonderful beautiful charming picturesque';

  var predictionPrompt = sanitizePrompt(prompt);

  predictionPrompt = predictionPrompt.replace(/[^a-zA-Z0-9 ]/g, '');
  var bgPrompt = `${predictionPrompt}`;
  bgPrompt = sanitizePrompt(bgPrompt);
  var bgPromptKey = encodeURIComponent(bgPrompt.replaceAll(' ', '-'));
  dataAccessor.makeAIImage(bgPrompt, bgPromptKey).then(function (response) {
    preloadImage(response.path, function () {
      var $chatLog = $('.chat-log');
      $chatLog.append(`<img src="${response.path}" class="ai-portrait" />`);
    });
  });
}
let setupEbankGameInit = function () {
  'use strict';
  window.questionsgame = {};
  var self = window.questionsgame;

  self.Game = function (input) {
    let greeting = fixtures.currentAI.greeting;
    if (fixtures.save_game_json && fixtures.save_game_json.backstory) {
      greeting = fixtures.save_game_json.backstory;
    }
    var gameState = {
      numQuestions: 0,
      input: input,
      backstory: fixtures.currentAI.description,
      greeting: greeting,
      allInputs: [],
      inputOutputPairs: [],
      originalInput: input,
      extra_lines: '',
      moves: 0,
      repetition_penalty: 1.4,
      currentCharacter: fixtures.currentAI,
    };
    var CharPrefixLength = (fixtures.currentAI?.name + ': ').length;
    var inputDisplayMessage = input.slice(CharPrefixLength);
    gameState.allInputs.push(input);
    appendToChatLog(`<div class="chat-log__item">
                            <div class="chat-log__message" contenteditable="true" spellcheck="false">${inputDisplayMessage}</div>
                        </div>`);

    gameState.constructUIFromSave = function (saveGame) {
      if (saveGame && saveGame.input_outputs) {
        var isUser = true;
        for (var i = 0; i < saveGame.input_outputs.length; i++) {
          var currentMessage = saveGame.input_outputs[i];
          if (isUser) {
            appendToChatLog(`<div class="chat-log__item chat-log__item--own">
                            <div class="chat-log__message" contenteditable="true" spellcheck="false">${currentMessage}</div>
                        </div>`);
          } else {
            appendToChatLog(`<div class="chat-log__item">
                            <div class="chat-log__message" contenteditable="true" spellcheck="false">${currentMessage}</div>
                        </div>`);
          }
          isUser = !isUser;
        }
      }
    };
    gameState.constructStateFromSave = function (saveGame) {
      if (saveGame && saveGame.input_outputs) {
        setupSaveGameState(gameState, saveGame.input_outputs);
      }
    };

    gameState.getNewPrompt = function () {
      gameState.numQuestions++;
    };

    gameState.render = function (target) {
      gameState.$target = $(target);
      gameState.$target.html(gameState.$html);
    };
    gameState.addInputOutputPair = function (inputText, output) {
      gameState.inputOutputPairs.push(inputText);
      gameState.inputOutputPairs.push(output);
    };

    gameState.constructStateFromSave(fixtures.save_game_json);
    gameState.constructUIFromSave(fixtures.save_game_json);
    fixtures.save_game_json = null;

    $('.chat-one-to-one-name-tags').html(
      getTagsTemplate(fixtures.currentAI.tags)
    );
    generateNewBackground(input);

    return gameState;
  };

  $('.form-horizontal').on('submit', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof window.canSendFreeMessage === 'function' && !(await window.canSendFreeMessage())) {
      return;
    }
    if (!(userData && userData.is_subscribed)) {
      if (subscribeMessageCounter >= 5) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'chat');
        return;
      }
    }
    reInitGameState(questionsgame.game);
    rebuildGameState(questionsgame.game);

    var sentText = $('.question-text').val();
    sentText = sanitizePrompt(sentText);

    setTimeout(function () {
      $('.question-text').val('');
      $('.question-text').focus();
    }, 300);
    if (sentText.length < 1) return;
    sentText = sentText.trim().replace(/\n+/g, '\n');

    var characterName = fixtures.currentAI?.name;
    var userName = 'Noo';
    if (window.userData) {
      userName =
        (window.userData &&
          (window.userData.username || window.userData.name)) ||
        'Noo';
    }
    questionsgame.game.input += `
${userName}: ${sentText}
${characterName}:`;
    questionsgame.game.allInputs.push(`${userName}: ${sentText}`);

    appendToChatLog(`<div class="chat-log__item chat-log__item--own">
                            <div class="chat-log__message" contenteditable="true" spellcheck="false">${sentText}</div>
                        </div>
                        <div class="chat-log__item loading-chat-bar">
                        </div>`);

    function fetch_result(num_retries) {
      var prompt = buildPrompt(questionsgame.game);

      var inputLength = prompt.length;

      var data = {
        text: prompt,
        number_of_results: 1,
        max_length: 100,
        min_length: 1,
        max_sentences: 1,
        min_probability: 0,
        stop_sequences: [
          questionsgame.game.currentCharacter.name + ':',

          ((userData && (userData.username || userData.name)) || 'User') + ':',

          'Noo:',
          'Adam:',
          'john:',
          'adam:',
          'Bob:',
          'George:',
        ],
        top_p: 0.93,
        top_k: 50,
        temperature: 1.0,
        repetition_penalty:
          questionsgame.game.repetition_penalty + Math.random() * 0.3,
        seed: 0,
        model: 'chat',
      };
      let onfulfilled = (data) => {
        console.log('Success:', data);
        let fullGeneratedText = data[0]['generated_text'];
        let generatedText = fullGeneratedText.substring(inputLength);

        let prediction = stripSpeakerLabel(
          generatedText,
          fixtures.currentAI?.name || 'AI'
        );
        if (!prediction || prediction.length === 0) {
          if (num_retries < 3) {
            return fetch_result(num_retries + 1);
          }
          prediction = Math.random() > 0.5 ? 'Yep' : 'Nope';
        }
        let userName = 'Noo';
        if (window.userData) {
          userName =
            (window.userData &&
              (window.userData.username || window.userData.name)) ||
            'Noo';
        }

        prediction = prediction.replace('{{user}}', userName);
        prediction = prediction.replace('{{ user}}', userName);
        prediction = prediction.replace('{{user }}', userName);
        prediction = prediction.replace('{{ user }}', userName);

        if (prediction === questionsgame.game.lastGeneratedText) {
          questionsgame.game.input =
            questionsgame.game.originalInput +
            `
${userName}: ${sentText}
${fixtures.currentAI?.name}: `;
          if (num_retries < 3) {
            return fetch_result(num_retries + 1);
          }
        }
        questionsgame.game.lastGeneratedText = prediction;

        questionsgame.game.addInputOutputPair(sentText, prediction);

        $('.loading-chat-bar').remove();
        console.log('Chat response rendering:', prediction);
        appendToChatLog(`<div class="chat-log__item">
                        <div class="chat-log__message" contenteditable="true" spellcheck="false">${prediction}</div>
                    </div>`);
        console.log('Chat response rendered successfully');

        const makeArtEnabled =
          (localStorage.getItem('makeArtEnabled') || '').toLowerCase().trim() === 'true';
        console.log(
          'Art generation enabled:',
          makeArtEnabled,
          'Prediction length:',
          prediction?.length
        );
        if (makeArtEnabled && prediction && prediction.length > 10) {
          const userContext = sentText ? `User: ${sentText}. ` : '';
          const fullContext = userContext + prediction;
          const artPrompt = fullContext.substring(0, 300);
          console.log('Full art prompt:', artPrompt);
          generateArtFromResponse(artPrompt, prediction);
        }

        if (typeof window.playSound === 'function') {
          window.playSound(prediction);
        }
        // Background generation probability: 100% in dev, 20% on production (ebank.nz)
        var backgroundProbability =
          window.location.hostname === 'localhost' ||
          window.location.hostname === '127.0.0.1'
            ? 1.0
            : 0.2;

        if (Math.random() < backgroundProbability) {
          generateNewBackgroundDebounced(prediction);
        }
        if (sentText.trim().indexOf('appears') > -1) {
          var sent = sanitizePrompt(sentText);
          generateAICharacterPortrait(
            `character portrait ${sent} ${prediction}`
          );
        }
      };

      var examples = questionsgame.game.inputOutputPairs;
      var route = '/api/chatpred';
      if (num_retries > 0) {
        chatPromise = fetch(api_base_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Rapid-API-Key': 'YHWEFVNWHXIWNGVSH',
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (response.status !== 200) {
              throw new Error('Bad response from server');
            }
            return response;
          })
          .then((response) => response.json())

          .catch((error) => {
            return fetch('/api/chatpred', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ query: data.text }),
            })
              .then((response) => response.json())
              .then((response_json) => {
                const response_json_lower = response_json.toLowerCase();
                if (
                  response_json_lower.indexOf('google') > -1 ||
                  response_json_lower.indexOf('language model') > -1 ||
                  response_json_lower.indexOf('apologize') > -1 ||
                  response_json_lower.indexOf('under development') > -1 ||
                  response_json_lower.indexOf('explicit content') > -1 ||
                  response_json_lower.indexOf('trained') > -1 ||
                  response_json_lower.indexOf('development') > -1 ||
                  response_json_lower.indexOf('bard') > -1 ||
                  response_json_lower.indexOf('human-like') > -1 ||
                  response_json_lower.indexOf('feedback') > -1
                ) {
                  return '';
                }
                return [
                  {
                    generated_text: data.text + response_json,
                  },
                ];
              })
              .catch((error) => {
                console.error('Error from TG:', error);
                return '';
              });
          });
      } else {
        let context =
          'You are a fun role play character named:' +
          fixtures.currentAI?.name +
          '\n' +
          (questionsgame.game.backstory || '');

        subscribeMessageCounter++;
        setCookie('subscribeMessageCounter', subscribeMessageCounter, 365);

        var chatPromise = fetch(route, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: sentText,
            context: context,
            examples: examples,
            greeting: sanitizePrompt(fixtures.currentAI.greeting || '').replace(
              '{{user}}',
              window.userData
                ? window.userData.username || window.userData.name || 'Noo'
                : 'Noo'
            ),
          }),
        })
          .then((response) => response.json())
          .then((response_json) => {
            var response_json_lower = response_json.toLowerCase();

            if (
              response_json_lower.indexOf('google') > -1 ||
              response_json_lower.indexOf('language model') > -1 ||
              response_json_lower.indexOf('sorry') > -1 ||
              response_json_lower.indexOf('i will not') > -1 ||
              response_json_lower.indexOf('apologize') > -1 ||
              response_json_lower.indexOf('under development') > -1 ||
              response_json_lower.indexOf('explicit content') > -1 ||
              response_json_lower.indexOf('trained') > -1 ||
              response_json_lower.indexOf('development') > -1 ||
              response_json_lower.indexOf('bard') > -1 ||
              response_json_lower.indexOf('human-like') > -1 ||
              response_json_lower.indexOf('feedback') > -1
            ) {
              return '';
            }

            if (
              response_json_lower.indexOf('openai') > -1 ||
              response_json_lower.indexOf('gpt') > -1 ||
              response_json_lower.indexOf('gpt-3') > -1 ||
              response_json_lower.indexOf('gpt3') > -1 ||
              response_json_lower.indexOf('ai language') > -1 ||
              response_json_lower.indexOf('language') > -1 ||
              response_json_lower.indexOf('model') > -1 ||
              response_json_lower.indexOf('not appropriate') > -1 ||
              response_json_lower.indexOf('not capable') > -1 ||
              response_json_lower.indexOf('artificial') > -1 ||
              response_json_lower.indexOf('intelligence') > -1 ||
              response_json_lower.indexOf('programmed') > -1 ||
              response_json_lower.indexOf('inappropriate') > -1 ||
              response_json_lower.indexOf('refrain') > -1 ||
              response_json_lower.indexOf('as a') > -1 ||
              response_json_lower.indexOf("i don't") > -1
            ) {
              return '';
            }
            return [
              {
                generated_text: data.text + response_json,
              },
            ];
          })

          .catch((error) => {
            return '';
          })
          .then((response_json) => {
            if (response_json.length > 0) {
              return response_json;
            }

            var TGPromise = fetch(api_base_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Rapid-API-Key': 'YHWEFVNWHXIWNGVSH',
              },
              body: JSON.stringify(data),
            })
              .then((response) => {
                if (response.status !== 200) {
                  throw new Error('Bad response from server');
                }
                return response;
              })
              .then((response) => response.json())

              .catch((error) => {
                var TGPromise = fetch(api_base_url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Rapid-API-Key': 'YHWEFVNWHXIWNGVSH',
                  },
                  body: JSON.stringify(data),
                })
                  .then((response) => {
                    if (response.status !== 200) {
                      throw new Error('Bad response from server');
                    }
                    return response;
                  })
                  .then((response) => response.json())

                  .catch((error) => {
                    return fetch('/api/chatpred', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },

                      body: JSON.stringify({
                        query: sentText,
                        context: context,
                        examples: examples,
                        greeting: sanitizePrompt(
                          fixtures.currentAI.greeting || ''
                        ).replace(
                          '{{user}}',
                          window.userData
                            ? window.userData.username ||
                                window.userData.name ||
                                'Noo'
                            : 'Noo'
                        ),
                      }),
                    })
                      .then((response) => response.json())
                      .then((response_json) => {
                        const response_json_lower = response_json.toLowerCase();
                        if (
                          response_json_lower.indexOf('google') > -1 ||
                          response_json_lower.indexOf('language model') > -1 ||
                          response_json_lower.indexOf('apologize') > -1 ||
                          response_json_lower.indexOf('under development') >
                            -1 ||
                          response_json_lower.indexOf('explicit content') >
                            -1 ||
                          response_json_lower.indexOf('trained') > -1 ||
                          response_json_lower.indexOf('development') > -1 ||
                          response_json_lower.indexOf('bard') > -1 ||
                          response_json_lower.indexOf('human-like') > -1 ||
                          response_json_lower.indexOf('feedback') > -1
                        ) {
                          return '';
                        }
                        return [
                          {
                            generated_text: data.text + response_json,
                          },
                        ];
                      })
                      .catch((error) => {
                        return '';
                      });
                  });
                console.error('Error from TG:', error);
                return TGPromise;
              });
            return TGPromise;
          });
      }

      var resultOnce = false;
      var resultFn = function (result) {
        if (resultOnce) {
          return;
        }
        resultOnce = true;
        onfulfilled(result);
      };
      var bothFailed = false;
      chatPromise.then((result) => {
        if (result) {
          return resultFn(result);
        }
        if (bothFailed) {
          if (num_retries < 3) {
            return fetch_result(num_retries + 1);
          }
        }
        bothFailed = true;
      });
    }

    fetch_result(0);
    return false;
  });

  $('#add-new-ai-form').submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    let ainame = $('#add-new-ai-form input[name="ainame"]').val();
    let aidescription = $('#aidescription').val();
    let aigreeting = $('#aigreeting').val();
    let newaiavatarurl = $(
      '#add-new-ai-form input[name="newaiavatarurl"]'
    ).val();
    let newaibucketname = $(
      '#add-new-ai-form input[name="newaibucketname"]'
    ).val();
    let aipublic = $('#add-new-ai-form input[name="publicai"]').is(':checked');
    dataAccessor
      .saveAICharacter(
        ainame,
        aidescription,
        aigreeting,
        newaiavatarurl,
        aipublic,
        newaibucketname
      )
      .then(() => {
        ReRenderCurrentGame();
        if (fixtures.currentAI.avatar_file_name) {
          var avatarFileName = fixtures.currentAI.avatar_file_name;

          if (avatarFileName) {
            avatarFileName = avatarFileName.replace(' ', '-');
          }
          avatarFileName = avatarFileName.trim();
          if (avatarFileName.indexOf('static/uploads') === -1) {
            avatarFileName = 'static/uploads/' + avatarFileName;
          }
          $('.chat-one-to-one-icon').attr(
            'src',
            'https://netwrckstatic.netwrck.com/' + avatarFileName
          );
        } else {
          $('.chat-one-to-one-icon').attr(
            'src',
            'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp'
          );
        }
        $('.chat-one-to-one-name').text(fixtures.currentAI?.name);
        $('.chat-one-to-one-name-tags').html(
          getTagsTemplate(fixtures.currentAI.tags)
        );
        $('.chat-one-to-one-name-tooltip').text(fixtures.currentAI.description);

        $('#add-chat-dialog')[0].close();
        $('#create-new-ai-dialog')[0].close();
        var urlkey = encodeURIComponent(
          fixtures.currentAI?.name.replace(/ /g, '-')
        );
        APP.goto('/ai-chat/' + urlkey);
      })
      .catch((error) => {
        console.error('Error creating AI character:', error);
      });
  });
  componentHandler.upgradeDom();
  if (typeof adsFix === 'function') {
    adsFix();
  }
  return self;
};
window.onceGameInit = false;
window.setupGameOnce = function () {
  if (window.onceGameInit) {
    return;
  }
  window.onceGameInit = true;
};
$(document).on('user-ready', function (evt, user) {
  'use strict';

  if (
    userData &&
    (userData.username || userData.name) &&
    !userData.is_subscribed
  ) {
    // Placeholder for unsubscribed user logic
  }
});
window.setTimeout(function () {
  window.setupGameOnce();
}, 5000);

function ReRenderCurrentGame() {
  let userName = 'Noo';
  if (window.userData) {
    userName =
      (window.userData && (window.userData.username || window.userData.name)) ||
      'Noo';
  }

  $('.chat-log').html('');

  let input = fixtures.currentAI.greeting
    ? fixtures.currentAI.greeting
    : fixtures.currentAI.description;
  if (fixtures.save_game_json && fixtures.save_game_json.backstory) {
    input = fixtures.save_game_json.backstory;
  }

  input = input.replace('{{name}}', userName);
  input = input.replace('{{user}}', userName);
  input = input.replace('[user]', userName);
  if (userName !== 'Noo') {
    input = input.replace(
      'Login and set your name or everyone calls you... Noo',
      'Hi ' + userName
    );
  }
  input = fixtures.currentAI?.name + ': ' + input;
  questionsgame.game = new questionsgame.Game(input);
  questionsgame.game.render($('#gameon-game'));

  // Ensure userData is defined with safe defaults
  const safeUserData = window.userData || {};
  const userNameForGreeting =
    safeUserData.username || safeUserData.name || 'Noo';

  questionsgame.game.lastGeneratedText = sanitizePrompt(
    fixtures.currentAI?.greeting || ''
  ).replace('{{user}}', userNameForGreeting);
  questionsgame.game.cannedResponseUsed = false;

  if (safeUserData?.is_subscribed) {
    $('.subscribe-btn-main').hide();
  }

  if (fixtures.currentAI?.voice) {
    setVoice(fixtures.currentAI.voice);
  }

  $('#main-chatbox').focus();
}
$(document).on('click', '#mic-talk', function () {
  var $mic = $(this);
  if (window.VoiceTranscribe && window.VoiceTranscribe.recording) {
    window.VoiceTranscribe.stop(true);
    return;
  }
  if (!window.VoiceTranscribe) {
    console.error('VoiceTranscribe not loaded');
    return;
  }

  VoiceTranscribe.onStateChange = function (state) {
    if (state === 'recording' || state === 'speaking') {
      $mic.addClass('pulse redish-icon');
      $mic.find('span').html('mic_off');
    } else if (state === 'transcribing') {
      $mic.addClass('pulse');
      $mic.removeClass('redish-icon');
      $mic.find('span').html('hourglass_top');
    } else {
      $mic.removeClass('pulse redish-icon');
      $mic.find('span').html('mic');
    }
  };

  VoiceTranscribe.onPartialText = function (text) {
    if (text) {
      $('.question-text').attr('placeholder', text + '...');
    }
  };

  VoiceTranscribe.onFinalText = function (text) {
    if (!text) return;
    var el = document.getElementsByClassName('question-text')[0];
    if (!el) return;
    var current = el.value || el.innerHTML || '';
    if (current.length > 0 && current[current.length - 1] !== ' ' && text[0] !== ' ') {
      text = ' ' + text;
    }
    if (el.tagName === 'TEXTAREA' || el.tagName === 'INPUT') {
      el.value += text;
    } else {
      el.innerHTML += text;
    }
    $('.question-text').attr('placeholder', 'Chat');
    $('.form-horizontal').submit();
  };

  VoiceTranscribe.start();
});

function setupDialog() {
  var dialog = document.querySelector('dialog');
  if (!dialog) {
    console.warn('setupDialog: No dialog element found in DOM');
    return;
  }

  if (dialog && dialog.showModal) {
    var closeBtn = dialog.querySelector('.close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (dialog && typeof dialog.close === 'function') {
          dialog.close();
        }
      });
    }
  } else {
    console.warn('setupDialog: Dialog element does not support showModal API');
  }

  $('#add-room-btn').click(function (event) {
    var dialog = document.getElementById('add-room-dialog');
    APPController.renderRooms();
    dialog?.close();
    dialog.showModal();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  $('#find-room-btn').click(function (event) {
    var dialog = document.getElementById('find-room-dialog');
    APPController.renderRooms();
    dialog?.close();
    dialog.showModal();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('.close').click(function (event) {
    var dialog = $(this).parents('dialog').get(0);
    dialog?.close();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('#add-contact-btn').click(function (event) {
    var dialog = document.getElementById('add-contact-dialog');
    dialog?.close();
    dialog.showModal();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('#add-chat-btn').click(function (event) {
    var dialog = document.getElementById('add-chat-dialog');

    dialog?.close();
    dialog.showModal();
    $('#searchusers').focus();

    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  $('#create-ai-profile-pic').click(function (event) {
    var dialog = document.getElementById('create-pic-dialog');

    dialog?.close();
    dialog.showModal();
    $('#createaiimageprompt').focus();

    populateElfStyles();

    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('.ai-art-generator-button').click(function (event) {
    var dialog = document.getElementById('create-pic-dialog');
    APPController.writeNewAItoLocationFunc =
      APPController.writeNewAItoLocationChatFunc;

    dialog?.close();
    dialog.showModal();
    $('#createaiimageprompt').focus();

    populateElfStyles();

    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('#create-user-profile-pic').click(function (event) {
    var dialog = document.getElementById('create-pic-dialog');
    APPController.writeNewAItoLocationFunc =
      APPController.writeNewAItoLocationCharacterDesignFunc;

    dialog?.close();
    dialog.showModal();
    $('#createaiimageprompt').focus();

    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  $('#create-new-ai-btn').click(function (event) {
    var authResult = isUserAuthenticated();
    if (!authResult.isAuthenticated) {
      if (
        window.showSubscribeDialog &&
        typeof window.showSubscribeDialog === 'function'
      ) {
        window.showSubscribeDialog();
      } else {
        window.location.href =
          '/login?next=' +
          encodeURIComponent(window.location.pathname + window.location.search);
      }
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    var dialog = document.getElementById('create-new-ai-dialog');

    dialog?.close();
    dialog.showModal();
    $('#ainame').focus();

    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  $('#share-button').click(function (event) {
    var dialog = document.getElementById('share-ai-dialog');
    window.setTimeout(function () {
      $('#share-code-url-text').val(window.location.href);
      $('#copy-url').attr('href', window.location.href);
      var documentTitle = document.title;
      $('#twitter-share-link').attr(
        'href',
        'https://x.com/intent/tweet?text=' +
          documentTitle +
          ' - ' +
          encodeURIComponent(window.location.href)
      );
      $('#facebook-share-link').attr(
        'href',
        'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(window.location.href) +
          '&t=' +
          encodeURIComponent(documentTitle)
      );
      $('#reddit-share-link').attr(
        'href',
        'https://www.reddit.com/submit?url=' +
          encodeURIComponent(window.location.href) +
          '&title=' +
          encodeURIComponent(documentTitle)
      );
      $('#linkedin-share-link').attr(
        'href',
        'https://www.linkedin.com/shareArticle?mini=true&url=' +
          encodeURIComponent(window.location.href) +
          '&title=' +
          encodeURIComponent(documentTitle)
      );
      $('#share-code-url-text').focus();
      $('#share-code-url-text').select();
    }, 300);

    dialog?.close();
    dialog.showModal();

    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('#save-button').click(function (event) {
    reInitGameState(questionsgame.game);
    var saveGame = rebuildGameState(questionsgame.game);

    var titleOfGame =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    fetch('/api/save-game', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: titleOfGame,
        input_outputs: saveGame.input_outputs,
        backstory: saveGame.backstory,
        display_title:
          document.getElementById('chat-one-to-one-name')?.textContent ||
          document.title,
        character_path:
          window.location.pathname +
          (function () {
            var params = new URLSearchParams(window.location.search);
            params.delete('saved_chat');
            params.delete('anon_chat');
            return params.toString() ? '?' + params.toString() : '';
          })(),
        kind: 'checkpoint',
      }),
    })
      .then(function (response) {
        if (response.status !== 200) {
          console.log(
            'Looks like there was a problem. Status Code: ' + response.status
          );
          throw new Error('Something went wrong saving!');
        }
        return response.json();
      })
      .then(function (data) {
        var dialog = document.getElementById('save-ai-dialog');
        window.setTimeout(function () {
          let locationUrl = new URL(window.location.href);
          let inputParams = new URLSearchParams(locationUrl.search);
          inputParams.set('saved_chat', titleOfGame);
          inputParams.delete('anon_chat');
          locationUrl.search = inputParams.toString();
          locationUrl = locationUrl.href;
          $('#save-code-url-text').val(locationUrl);
          $('#save-copy-url').attr('href', locationUrl);
          if (window.ChatWorkspace) {
            window.ChatWorkspace.saveChat({
              id: titleOfGame,
              url: locationUrl,
              title:
                document.getElementById('chat-one-to-one-name')?.textContent ||
                document.title,
              saved: true,
              owned: true,
              kind: 'checkpoint',
            });
          }
          var documentTitle = document.title;
          $('#twitter-save-link').attr(
            'href',
            'https://x.com/intent/tweet?text=' +
              documentTitle +
              ' - ' +
              encodeURIComponent(locationUrl)
          );
          $('#facebook-save-link').attr(
            'href',
            'https://www.facebook.com/sharer/sharer.php?u=' +
              encodeURIComponent(locationUrl) +
              '&t=' +
              encodeURIComponent(documentTitle)
          );
          $('#reddit-save-link').attr(
            'href',
            'https://www.reddit.com/submit?url=' +
              encodeURIComponent(locationUrl) +
              '&title=' +
              encodeURIComponent(documentTitle)
          );
          $('#linkedin-save-link').attr(
            'href',
            'https://www.linkedin.com/shareArticle?mini=true&url=' +
              encodeURIComponent(locationUrl) +
              '&title=' +
              encodeURIComponent(documentTitle)
          );
          $('#save-code-url-text').focus();
          $('#save-code-url-text').select();
        }, 300);

        dialog?.close();
        dialog.showModal();
      })
      .catch(function (err) {
        alert('Error saving game (please try again): ' + err);
      });

    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('#copy-url').click(function () {
    var $temp = $('<input>');
    $('body').append($temp);
    $temp.val($('#copy-url').attr('href')).select();
    document.execCommand('copy');
    navigator.clipboard.writeText($('#copy-url').attr('href'));
    $('#share-code-url-text').focus();
    $('#share-code-url-text').select();
    $temp.remove();
  });

  $('#save-copy-url').click(function () {
    var $temp = $('<input>');
    $('body').append($temp);
    $temp.val($('#save-copy-url').attr('href')).select();
    document.execCommand('copy');
    navigator.clipboard.writeText($('#save-copy-url').attr('href'));
    $('#save-code-url-text').focus();
    $('#save-code-url-text').select();
    $temp.remove();
  });

  window.searchCat = function (cat) {
    $('#searchusers').val('');
    $('#searchusers').focus();
    safeSendKeys($('#searchusers'), cat);
    $('#searchusers').focus();

    onTypingAIFunction();
    return false;
  };
  window.addGenerationCat = function (cat) {
    let currentVal = $('#createaiimageprompt').val();
    var isFinishingSpace = currentVal[currentVal.length - 1] === ' ';
    if (!isFinishingSpace && currentVal[currentVal.length - 1]) {
      cat = ' ' + cat;
    }
    $('#createaiimageprompt').focus();

    var input = $('#createaiimageprompt')[0];
    input.selectionStart = input.selectionEnd = input.value.length;
    safeSendKeys($('#createaiimageprompt'), cat);
    $('#createaiimageprompt').focus();

    return false;
  };

  // showSubscribeDialog is already defined in shared.js with better functionality
  // Just bind the click handler to use the existing function
  $(document).on('click', '.subscribe-btn', function(event) {
    if (window.showSubscribeDialog) {
      return window.showSubscribeDialog(event);
    }
    console.warn('showSubscribeDialog not found');
    return false;
  });
  // Ensure signup links open the signup modal directly
  $(document).on('click', '.signup-link', function (event) {
    if (typeof window.showSignupDialog === 'function') {
      return window.showSignupDialog(event);
    }
    window.location.href = '/signup#modal';
    return false;
  });

  $('#subscribe-dialog .close').click(function (event) {
    var dialog = document.getElementById('subscribe-dialog');
    dialog?.close();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  $('#add-room-form').submit(function (event) {
    if (window.sessionManager && window.sessionManager.isAuthenticated()) {
      var user = window.sessionManager.getCurrentUser();
      if (user) {
        var displayName = user.username;
        var email = user.email;
        var photoURL = user.photoURL;
        var uid = user.uid;
        var phoneNumber = user.phoneNumber;
        var providerData = user.providerData;
        getUser(user, function (data) {
          var email = data['email'];
          $('.email').html(email);

          const api_key = data['secret'];
          var roomName = $("#add-room-form input[name='roomname']").val();
          var roomVisibility = $(
            "#add-room-form input[name='public']:checked"
          ).val();
          $.ajax({
            url: '/new-chatroom',
            type: 'POST',
            data: {
              secret: api_key,
              roomname: roomName,
              public: roomVisibility,
            },
            success: function (data) {
              console.log(data);
              var dialog = document.getElementById('add-room-dialog');
              dialog?.close();
              APPController.enterRoom(roomName);
            },
            error: function (data) {
              console.log(data);
            },
          });
        });
      } else {
        location.href = '/signup';
      }
    } else {
      location.href = '/signup';
    }

    var dialog = document.getElementById('add-room-dialog');
    dialog?.close();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  let onTypingFunction = function (event) {
    var query = $(this).val();
    APPController.renderRooms(null, query);
  };

  $('#searchrooms').on('input', onTypingFunction);

  $('#main-chatbox').keydown(function (event) {
    var key = event.keyCode || event.charCode;

    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) {
      return true;
    }

    if (key === 13) {
      event.preventDefault();
      event.stopPropagation();
      var $form = $(this).closest('form');
      $form.submit();
    }
  });
  $('.createaiimageprompt').focus();

  window.setTimeout(function () {
    $('.typeahead').css('backgroundColor', '#f7ebd4');
  }, 2000);

  var onTypingAIFunction = function (event) {
    var query = $('#searchusers').val();
    APPController.renderAIs(null, query);
  };

  $('.search-ais-button').click(function (event) {
    onTypingAIFunction(event);
  });

  $('#searchusers').keydown(function (event) {
    if (window.userFullyLoaded && !(userData && userData.is_subscribed)) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');

        return;
      }
    }

    if (event.keyCode === 13) {
      onTypingAIFunction(event);
    }
  });

  var onTypingCreateAIFunction = function (event) {
    var query = $('#createaiimageprompt').val();
    APPController.renderAIPics(null, query);
  };

  var pendingArtKey = 'ebankPendingArtGeneration';

  function savePendingArtGeneration() {
    var prompt = $('#createaiimageprompt').val();
    var aspect = $('input[name="aspect"]:checked').attr('id') || '';
    try {
      sessionStorage.setItem(
        pendingArtKey,
        JSON.stringify({ prompt: prompt, aspect: aspect, createdAt: Date.now() })
      );
    } catch {}
  }

  function clearPendingArtGeneration() {
    try {
      sessionStorage.removeItem(pendingArtKey);
    } catch {}
  }

  window.resumePendingEbankArtGeneration = function () {
    var pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(pendingArtKey) || 'null');
    } catch {
      clearPendingArtGeneration();
      return false;
    }
    if (!pending || !pending.prompt || Date.now() - pending.createdAt > 1800000) {
      clearPendingArtGeneration();
      return false;
    }
    if (!isUserAuthenticated().isAuthenticated) return false;

    $('#createaiimageprompt').val(pending.prompt);
    if (pending.aspect) {
      var aspect = document.getElementById(pending.aspect);
      if (aspect) aspect.checked = true;
    }
    clearPendingArtGeneration();

    if (window.userData && window.userData.is_subscribed) {
      window.userFullyLoaded = true;
      window.setTimeout(function () {
        onTypingCreateAIFunction();
      }, 0);
    } else {
      window.setTimeout(function () {
        window.showSubscribeDialog();
      }, 0);
    }
    return true;
  };

  window.addEventListener('userLoggedIn', window.resumePendingEbankArtGeneration);
  window.addEventListener('userSignedUp', window.resumePendingEbankArtGeneration);
  window.setTimeout(window.resumePendingEbankArtGeneration, 500);

  $('.create-ai-image-button').click(function (event) {
    if (!(window.userData && window.userData.is_subscribed)) {
      savePendingArtGeneration();
    } else {
      clearPendingArtGeneration();
    }
    if (!(userData && userData.is_subscribed) && window.userFullyLoaded) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');

        return;
      }
    }

    onTypingCreateAIFunction(event);
  });

  $('#createaiimageprompt').keydown(function (event) {
    if (event.keyCode === 13 && !(window.userData && window.userData.is_subscribed)) {
      savePendingArtGeneration();
    }
    if (!(userData && userData.is_subscribed) && window.userFullyLoaded) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');

        return;
      }
    }

    if (event.keyCode === 13) {
      onTypingCreateAIFunction(event);
    }
  });

  $(document).on('click', '.mdl-download-btn', function (evt) {
    var downloadClass = $(evt.currentTarget).data('download');
    var $imgToDownload = $(`.${downloadClass}`);
    var imgSrcAttr = $imgToDownload.attr('src');

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    $imgToDownload[0].crossOrigin = 'anonymous';

    $imgToDownload.on('load', function () {
      canvas.width = $imgToDownload[0].naturalWidth;
      canvas.height = $imgToDownload[0].naturalHeight;

      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage($imgToDownload[0], 0, 0);

      var link = document.createElement('a');
      var fileName = window.ImageUtils.getImageName(
        imgSrcAttr.replace('.webp', '')
      );
      window.setTimeout(function () {
        link.download = fileName + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
      }, 100);
    });

    if ($imgToDownload[0].complete || $imgToDownload[0].naturalWidth !== 0) {
      $imgToDownload.trigger('load');
    }
  });

  $(document).on('click', '.mdl-style-transf-btn', function (evt) {
    if (window.userFullyLoaded && !(userData && userData.is_subscribed)) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');

        return;
      }
    }

    const $mainInput = $('#createaiimageprompt');
    $mainInput.focus();

    $('html, body').animate(
      {
        scrollTop: $mainInput.offset().top,
      },
      500
    );

    var downloadClass = $(evt.currentTarget).data('download');
    var $imgToDownload = $(evt.currentTarget)
      .closest('.ai-generated-char-chooser, .mdl-card, .ai-char-item')
      .find(`.${downloadClass}`);
    var imgSrcAttr = $imgToDownload.attr('src');
    window.setDropzoneImgToUrl(imgSrcAttr);
  });
  $(document).on('click', '.mdl-upres-btn', function (evt) {
    if (window.userFullyLoaded && !(userData && userData.is_subscribed)) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');

        return;
      }
    }
    var dialog = document.getElementById('upres-dialog');

    dialog?.close();
    dialog.showModal();

    var downloadClass = $(evt.currentTarget).data('download');
    var $imgToDownload = $(`.${downloadClass}`);
    var imgSrcAttr = $imgToDownload.attr('src');
    var imgAltAttr = $imgToDownload.attr('alt');
    var baseUrl = '';

    $('#high-res-result-image').html(`
            <div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div>
        `);
    fetch(baseUrl + '/run', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model_name:
          'philz1337x/clarity-upscaler:b8a46b09384dc1ac996596bc14058e2b7604971128ee7de709a40d4bbf982d2c',
        seed: 1337,
        image: imgSrcAttr,
        prompt: imgAltAttr,
        dynamic: 6,
        sd_model: 'juggernaut_reborn.safetensors [338b85bc4f]',
        scheduler: 'DPM++ 3M SDE Karras',
        creativity: 0.35,
        lora_links: '',
        downscaling: false,
        resemblance: 0.6,
        scale_factor: 2,
        tiling_width: 112,
        tiling_height: 144,
        custom_sd_model: '',
        negative_prompt:
          '(worst quality, low quality, normal quality:2) JuggernautNegative-neg',
        num_inference_steps: 25,
        downscaling_resolution: 768,
        dmal:
          new Date().toLocaleString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            year: '2-digit',
            timeZone: 'UTC',
          }) +
          'asdf' +
          ((window.userData && window.userData.is_subscribed) || false) +
          'asdf' +
          ((window.userData && window.userData.secret) || ''),
      }),
    })
      .then(async function (result) {
        if (!result.ok) {
          var errorData = await result.json();
          if (result.status === 401 && errorData.redirect) {
            window.location.href =
              errorData.redirect +
              '?next=' +
              encodeURIComponent(
                window.location.pathname + window.location.search
              );
            return;
          } else if (result.status === 402) {
            if (typeof window.showSubscribeDialog === 'function') {
              window.showSubscribeDialog();
            }
            return;
          }
          throw new Error(errorData.error || 'Request failed');
        }
        var decoded = await result.json();
        var filefullURLEncoded = encodeURIComponent(decoded.output);
        var i = 99999;
        $('#high-res-result-image').html(`


<div class="ai-character-item-aiart ai-char-item mdl-cell mdl-cell--stretch mdl-cell--2-col mdl-list__item mdl-list__item--three-line" >
  <a id="mdl-editor-btn-${i}" href="https://editor.ebank.nz/index.html?imageUrl=${filefullURLEncoded}"
                       class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank">
                          <i class="material-icons">brush</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-editor-btn-${i}">
                        Open in Editor
                    </label>
                    <a id="mdl-download-btn-${i}"
                       class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">download</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-download-btn-${i}">
                        Download
                    </label>
                    <a class="mdl-list__item-primary-content" href="aiartgenerator?c=${encodeURIComponent(imgAltAttr)}">

        <span class="mdl-list__item-avatar-aiart mdl-chip__contact mdl-list__item-avatar">
            <img id="aiartgenerator-image${i}" loading="lazy" class="jspicture${i} ai-avatar-icon--aiart ai-generated-char-chooser ai-avatar-icon" src="${decoded.output}" alt="${imgAltAttr}">
            <label class="mdl-tooltip mdl-tooltip-large mdl-tooltip--top" data-mdl-for="aiartgenerator-image${i}">
                ${imgAltAttr}
            </label>
        </span>
    </a>

</div>
</div>

            `);
      })
      .catch(function (err) {
        $('#high-res-result-image').html(`Error please try again`);
        console.log(err);
      });
  });

  $(document).on('click', '.mdl-video-btn', function (evt) {
    if (window.userFullyLoaded && !(userData && userData.is_subscribed)) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');

        return;
      }
    }
    var downloadClass = $(evt.currentTarget).data('download');
    var $imgToDownload = $(`.${downloadClass}`);
    var imgSrcAttr = $imgToDownload.attr('src');
    var imgAltAttr = $imgToDownload.attr('alt');
    if (window.LTX23VideoDialog && typeof window.LTX23VideoDialog.open === 'function') {
      evt.preventDefault();
      window.LTX23VideoDialog.open({
        imageUrl: imgSrcAttr,
        prompt:
          imgAltAttr ||
          'The character moves naturally with subtle animation and graceful gestures',
      });
    }
  });

  $(document).on('click', '.mdl-bgremove-btn', function (evt) {
    evt.preventDefault();
    if (window.userFullyLoaded && !(userData && userData.is_subscribed)) {
      if (subscribeImageGenCounter >= 0) {
        window.showSubscribeDialog();
        trackEvent('user', 'paywall', 'art');
        return;
      }
    }
    var dialog = document.getElementById('bgremove-dialog');
    if (!dialog) return;
    dialog?.close();
    dialog.showModal();

    var downloadClass = $(evt.currentTarget).data('download');
    var $img = $(`.${downloadClass}`);
    var imgSrc = $img.attr('src');
    var imgAlt = $img.attr('alt') || 'art';

    $('#bgremove-result-image').html(
      '<div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div>'
    );
    if (typeof componentHandler !== 'undefined') componentHandler.upgradeDom();

    var secret = window.userData && window.userData.secret;
    var headers = { 'Content-Type': 'application/json' };
    if (secret && secret !== 'anonymous') {
      headers['X-API-Key'] = secret;
      headers['Authorization'] = 'Bearer ' + secret;
    }

    fetch('/api/remove-background', {
      method: 'POST',
      headers: headers,
      credentials: 'include',
      body: JSON.stringify({
        image_url: imgSrc,
        output_format: 'png',
        api_key: secret || ''
      })
    })
      .then(function (res) {
        if (!res.ok) {
          if (res.status === 401) {
            window.location.href = '/login?next=' + encodeURIComponent(window.location.pathname);
            return;
          }
          if (res.status === 402) {
            if (typeof window.showSubscribeDialog === 'function') window.showSubscribeDialog();
            dialog.close();
            return;
          }
          throw new Error('Request failed: ' + res.status);
        }
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        var resultUrl = '';
        if (data.result && data.result.image && data.result.image.url) {
          resultUrl = data.result.image.url;
        } else if (data.result && data.result.url) {
          resultUrl = data.result.url;
        }
        if (!resultUrl) {
          $('#bgremove-result-image').html('No result returned');
          return;
        }
        var idx = 88888;
        $('#bgremove-result-image').html(
          '<div class="img-art-container" style="display:inline-block">' +
          '<a id="mdl-download-btn-bgr' + idx + '"' +
          ' class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored"' +
          ' target="_blank" data-download="bgrpicture' + idx + '" title="Download">' +
          '<i class="material-icons">download</i></a>' +
          '<img class="bgrpicture' + idx + ' ai-avatar-icon--aiart ai-generated-char-chooser" ' +
          'src="' + resultUrl + '" alt="' + imgAlt + ' (background removed)" ' +
          'style="max-width:100%;max-height:80vh;border-radius:8px;background:repeating-conic-gradient(#ccc 0% 25%, #fff 0% 50%) 50%/16px 16px">' +
          '</div>'
        );
        if (typeof componentHandler !== 'undefined') componentHandler.upgradeDom();
      })
      .catch(function (err) {
        console.error('bg remove error:', err);
        $('#bgremove-result-image').html('Error: ' + err.message);
      });
  });
}

function setupSearch(rooms) {}

$(document).ready(function () {
  setupDialog();
});
const copyEbankInviteLink = async () => {
  var text = $('#invite-link')[0].innerHTML;

  try {
    await navigator.clipboard.writeText(text);
    console.log('Content copied to clipboard');
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
};

var dataAccessor = (function () {
  var dataAccessorSelf = {};
  dataAccessorSelf.allRooms = [];

  const baseProxyUrl = '';
  dataAccessorSelf.falFetch = function (data) {
    var secret = window.userData && window.userData.secret;
    var headers = { 'Content-Type': 'application/json' };
    if (secret && secret !== 'anonymous') {
      headers['X-API-Key'] = secret;
      headers['Authorization'] = 'Bearer ' + secret;
    }
    return fetch(baseProxyUrl + '/fal', {
      method: 'POST',
      headers: headers,
      credentials: 'include',
      body: JSON.stringify(data),
    }).then(function (response) {
      if (response.status === 401) {
        if (window.thFunnel) window.thFunnel.paywall('auth_required', { feature: 'art' });
        if (typeof window.showLoginDialog === 'function') {
          window.showLoginDialog(null, window.location.pathname);
        }
        throw new Error('Authentication required');
      }
      if (response.status === 402) {
        if (typeof window.showSubscribeDialog === 'function') {
          window.showSubscribeDialog();
        }
        throw new Error('Subscription required');
      }
      return response;
    });
  };
  dataAccessorSelf.getWidthHeight = function () {
    var aspect = dataAccessorSelf.getAspect();
    var width = 1024;
    var height = 1024;
    if (aspect === 'square') {
      // Default values already set
    }
    if (aspect === 'landscape') {
      width = 1152;
      height = 768;
    }
    if (aspect === 'portrait') {
      width = 768;
      height = 1152;
    }
    if (aspect === 'landscape43') {
      width = 1152;
      height = 846;
    }
    if (aspect === 'portrait43') {
      width = 846;
      height = 1152;
    }
    if (aspect === 'widescreen') {
      width = 1360;
      height = 768;
    }
    if (aspect === 'tall') {
      width = 768;
      height = 1360;
    }
    if (aspect === 'hdwidescreen') {
      width = 1920;
      height = 1080;
    }
    if (aspect === 'hdtall') {
      width = 1080;
      height = 1920;
    }
    return { aspect, width, height };
  };
  dataAccessorSelf.getKeyForSDSize = function () {
    var aspectMap = {
      square: 'square_hd',
      landscape: 'landscape_16_9',
      portrait: 'portrait_16_9',
      landscape43: 'landscape_4_3',
      portrait43: 'portrait_4_3',
      widescreen: 'landscape_16_9',
      tall: 'portrait_16_9',
      hdwidescreen: 'landscape_16_9',
      hdtall: 'portrait_16_9',
    };
    var aspect = dataAccessorSelf.getAspect();
    return aspectMap[aspect];
  };
  dataAccessorSelf.getAllRooms = function (callback) {
    if (dataAccessorSelf.allRooms.length > 0) {
      callback(dataAccessorSelf.allRooms);
      return;
    }
    $.ajax({
      url: '/api/get-all-rooms',
      type: 'GET',
      success: function (data) {
        var rooms = data.rooms || data;
        dataAccessorSelf.allRooms = rooms;
        callback(rooms);
      },
      error: function (data) {
        console.log(data);

        callback([]);
      },
    });
  };
  var searchBaseUrl = fixtures['search_base_url'] || '';

  if (searchBaseUrl && searchBaseUrl.indexOf('localhost') > -1) {
    searchBaseUrl = '';
  }
  dataAccessorSelf.searchAis = function (query) {
    var params = new URLSearchParams({ query: query });
    if (window.addAllowNSFWParam) {
      window.addAllowNSFWParam(params);
    }

    return fetch(
      searchBaseUrl + '/api/search-ais?' + params.toString(),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then(function (response) {
        if (!response.ok) {
          console.warn('Search API returned non-OK status:', response.status);
          return [];
        }
        return response.json();
      })
      .catch(function (error) {
        console.error('Error:', error);
        return []; // Return empty array on error instead of undefined
      });
  };
  dataAccessorSelf.searchAiImages = function (query, offset, limit) {
    var imageParams = new URLSearchParams({
      query: query,
      offset: offset || 0,
      limit: limit || 120,
    });
    if (window.addAllowNSFWParam) {
      window.addAllowNSFWParam(imageParams);
    }

    return fetch(
      searchBaseUrl + '/api/search-aiimages?' + imageParams.toString(),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then(function (response) {
        if (!response.ok) {
          console.warn(
            'Search AI Images API returned non-OK status:',
            response.status
          );
          return [];
        }
        return response.json();
      })
      .catch(function (error) {
        console.error('Error:', error);
        return []; // Return empty array on error instead of undefined
      });
  };

  dataAccessorSelf.getAspect = function () {
    let squareAspect = $('#squareaspect').is(':checked');
    if (squareAspect) {
      return 'square';
    }

    let landscapeAspect = $('#landscapeaspect').is(':checked');
    if (landscapeAspect) {
      return 'landscape';
    }
    let portraitAspect = $('#portraitaspect').is(':checked');
    if (portraitAspect) {
      return 'portrait';
    }
    let landscape43aspect = $('#landscape43aspect').is(':checked');
    if (landscape43aspect) {
      return 'landscape43';
    }
    let portrait43aspect = $('#portrait43aspect').is(':checked');
    if (portrait43aspect) {
      return 'portrait43';
    }
    let widescreenaspect = $('#widescreenaspect').is(':checked');
    if (widescreenaspect) {
      return 'widescreen';
    }
    let tallAspect = $('#tallaspect').is(':checked');
    if (tallAspect) {
      return 'tall';
    }
    let hdwidescreenAspect = $('#hdwidescreenaspect').is(':checked');
    if (hdwidescreenAspect) {
      return 'hdwidescreen';
    }
    let hdtallAspect = $('#hdtallaspect').is(':checked');
    if (hdtallAspect) {
      return 'hdtall';
    }

    return 'square';
  };
  dataAccessorSelf.makeAIImage = function (prompt, name) {
    var sizeKey = dataAccessorSelf.getKeyForSDSize();

    var falargs = {
      prompt: prompt,
      model_name: 'fal-ai/flux/schnell',
      image_size: sizeKey,
      num_inference_steps: 4,
      guidance_scale: 3.5,
      num_images: 1,
      enable_safety_checker: false,
    };

    return dataAccessorSelf.falFetch(falargs).then(async function (result) {
      var decoded = await result.json();
      if (!decoded.result || !decoded.result.images || !decoded.result.images[0]) {
        throw new Error('Invalid response from fal');
      }
      var filefullURL = decoded.result.images[0].url;
      return {
        path: filefullURL,
      };
    });
  };

  dataAccessorSelf._oldMakeAIImage = function (prompt, name) {
    var serverNames = ['image', 'images2'];

    var serverName =
      serverNames[Math.floor(Math.random() * serverNames.length)];

    var aspect = dataAccessorSelf.getAspect();
    var extraArgs = '';
    var extraName = '';
    var width = 1024;
    var height = 1024;
    if (aspect === 'square') {
      // Default values already set
    }
    if (aspect === 'landscape') {
      width = 1152;
      height = 768;
    }
    if (aspect === 'portrait') {
      width = 768;
      height = 1152;
    }
    if (aspect === 'landscape43') {
      width = 1152;
      height = 846;
    }
    if (aspect === 'portrait43') {
      width = 846;
      height = 1152;
    }
    if (aspect === 'widescreen') {
      width = 1360;
      height = 768;
    }
    if (aspect === 'tall') {
      width = 768;
      height = 1360;
    }
    if (aspect === 'hdwidescreen') {
      width = 1920;
      height = 1080;
    }
    if (aspect === 'hdtall') {
      width = 1080;
      height = 1920;
    }
    if (aspect != 'square') {
      extraArgs = `&width=${width}&height=${height}`;
      extraName = '-' + aspect;
    }
    return fetch(
      `https://${serverName}.netwrck.com/create_and_upload_image?save_path=ai/${name}${extraName}.webp&prompt=${prompt}${extraArgs}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then(function (response) {
      return response.json();
    });
  };
  dataAccessorSelf.makeAIStyleTransferImage = function (
    prompt,
    name,
    styleImgUrl
  ) {
    var sizeKey = dataAccessorSelf.getKeyForSDSize();

    var falargs = {
      prompt: prompt,
      model_name: 'fal-ai/flux-pro/kontext',
      image_url: styleImgUrl,
    };

    return dataAccessorSelf.falFetch(falargs).then(async function (result) {
      var decoded = await result.json();
      if (!decoded.result || !decoded.result.images || !decoded.result.images[0]) {
        throw new Error('Invalid response from fal');
      }
      var filefullURL = decoded.result.images[0].url;
      return {
        path: filefullURL,
      };
    });
  };
  dataAccessorSelf.makeRA2Image = function (prompt) {
    var secret = window.userData && window.userData.secret;
    var endpoint = window.NETWRCK_DEFAULT_ART_ENDPOINT || '/api/ra2';
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': secret,
        Authorization: 'Bearer ' + secret,
      },
      credentials: 'include',
      body: JSON.stringify({
        prompt: prompt,
        size: dataAccessorSelf.getKeyForSDSize(),
        api_key: secret,
        secret: secret,
      }),
    }).then(async function (response) {
      if (response.status === 401 || response.status === 402 || response.status === 403) {
        if (typeof window.showSubscribeDialog === 'function') {
          window.showSubscribeDialog();
          trackEvent('user', 'paywall', 'ra2');
        } else if (typeof window.showLoginDialog === 'function') {
          window.showLoginDialog(null, window.location.pathname);
        }
        throw new Error('Subscription required');
      }
      var data = await response.json().catch(function () {
        return null;
      });
      var image = data && data.result && data.result.images && data.result.images[0];
      if (!response.ok || !image || !image.url) {
        throw new Error('ra2 failed: ' + response.status);
      }
      return { path: image.url };
    });
  };
  dataAccessorSelf.getAIByName = function (name) {
    return fetch(
      '/api/get-ai-by-name?' +
        new URLSearchParams({
          ai_name: name,
        }),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  };
  dataAccessorSelf.saveAICharacter = function (
    ainame,
    aidescription,
    aigreeting,
    newaiavatarurl,
    aipublic,
    newaibucketname
  ) {
    return fetch('/api/create-ai', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        name: ainame,
        description: aidescription,
        greeting: aigreeting,
        image_url: newaiavatarurl,
        newaibucketname: newaibucketname,
        visibility: aipublic,
        secret:
          (window.userData && (window.userData.secret || window.userData.api_key)) ||
          window.userSecret ||
          (typeof localStorage !== 'undefined'
            ? localStorage.getItem('userSecret')
            : '') ||
          '',
      }),
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Bad response from server');
        }
        return response.json();
      })
      .then((response_json) => {
        window.fixtures = window.fixtures || {};
        window.fixtures.currentAI = {
          name: ainame,
          description: aidescription,
          greeting: aigreeting,
          avatar_file_name: newaiavatarurl,
        };
        window.currentAI = window.fixtures.currentAI;
        window.currentName = ainame;
        dataAccessor.aisByName[window.currentName] = window.fixtures.currentAI;

        if (window.currentAI) {
          window.fixtures.currentAI = window.currentAI;
        }
      })
      .catch((error) => {
        console.error('Error:', error);

        window.fixtures = window.fixtures || {};
        window.fixtures.currentAI = {
          name: ainame,
          description: aidescription,
          greeting: aigreeting,
          avatar_file_name: newaiavatarurl,
        };
        window.currentAI = window.fixtures.currentAI;
        window.currentName = ainame;
        dataAccessor.aisByName[window.currentName] = window.fixtures.currentAI;

        if (window.currentAI) {
          window.fixtures.currentAI = window.currentAI;
        }
      });
  };

  dataAccessorSelf.topAIs = function (secret) {
    if (dataAccessorSelf.topAIsData) {
      return Promise.resolve(dataAccessorSelf.topAIsData);
    }

    const url = secret ? `/api/top-ais?secret=${secret}` : '/api/top-ais';

    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((serverResponse) => {
        let data = [];

        const serverData =
          serverResponse && serverResponse.data
            ? serverResponse.data
            : serverResponse;

        if (serverData && Array.isArray(serverData) && serverData.length > 0) {
          data = serverData.map((ai) => ({
            avatar_file_name:
              ai.image_url || ai.avatar_file_name || 'default_avatar.png',
            description: ai.description || '',
            name: ai.name || 'Unknown',
            greeting: ai.greeting || `Hello! I'm ${ai.name || 'here to help'}.`,
            tags: ai.tags
              ? typeof ai.tags === 'string'
                ? ai.tags.split(',').map((t) => t.trim())
                : ai.tags
              : [],
            num_interactions: ai.popularity || ai.num_interactions || 0,
          }));
        }

        if (userData && userData.secret) {
          return fetch('/api/get-characters-for-user', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((response) => response.json())
            .then((userChars) => {
              if (userChars && Array.isArray(userChars)) {
                const userAIs = userChars.map((ai) => ({
                  avatar_file_name: ai.avatar_file_name || 'default_avatar.png',
                  description: ai.description || '',
                  name: ai.name || 'Unknown',
                  greeting:
                    ai.greeting || `Hello! I'm ${ai.name || 'here to help'}.`,
                  tags: ai.tags
                    ? typeof ai.tags === 'string'
                      ? ai.tags.split(',').map((t) => t.trim())
                      : ai.tags
                    : [],
                  num_interactions: ai.num_interactions || 0,
                  is_user_created: true,
                }));

                const existingNames = new Set(userAIs.map((ai) => ai.name));
                const uniqueServerAIs = data.filter(
                  (ai) => !existingNames.has(ai.name)
                );
                data = [...userAIs, ...uniqueServerAIs];
              }
              return data;
            })
            .catch((err) => {
              console.log('Could not fetch user characters:', err);
              return data;
            });
        } else {
          return data;
        }
      })
      .then((finalData) => {
        dataAccessorSelf.topAIsData = finalData;
        dataAccessorSelf.initialAIs = finalData;

        if (!dataAccessorSelf.aisByName) {
          dataAccessorSelf.aisByName = {};
        }

        finalData.forEach((ai) => {
          if (ai && ai.name) {
            dataAccessorSelf.aisByName[ai.name] = ai;
          }
        });

        return finalData;
      })
      .catch((error) => {
        console.error('Error fetching top AIs:', error);

        dataAccessorSelf.topAIsData = [];
        return [];
      });
  };
  return dataAccessorSelf;
})();

var APPController = (function () {
  var appControllerSelf = {};

  appControllerSelf.renderRooms = function ($target, searchQuery) {
    var render = function (rooms) {
      var $target = $('#autoCompleteRoomsList');
      var template = '';
      for (var i = 0; i < rooms.length; i++) {
        var room = rooms[i];
        if (!room || !room.name) continue;
        const slug =
          room.room_key && typeof room.room_key === 'string' && room.room_key.trim()
            ? room.room_key
            : room.name.replace(/ /g, '-').toLowerCase();
        const urlencodedName = encodeURIComponent(slug);
        template += `<a class="mdl-chip mdl-chip--contact" href="/r/${urlencodedName}"><span class="mdl-chip__contact mdl-color-text--white">#</span><span class="mdl-chip__text">${room.name}</span></a>`;
      }
      $target.html(template);
    };

    if (searchQuery && searchQuery.trim().length > 0) {
      dataAccessor.searchRooms(searchQuery.trim(), function (rooms) {
        render(rooms);
      });
      return;
    }

    dataAccessor.getAllRooms(function (rooms) {
      render(rooms);
    });
  };
  let renderAIView = function (ais) {
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      if (ai.name.startsWith('ai ')) {
        ai.name = ai.name.slice(3);
      }
    }
    dataAccessor.currentAIs = ais;

    dataAccessor.aisByName = dataAccessor.aisByName || {};
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      dataAccessor.aisByName[ai.name] = ai;
    }

    var $target = $('#autoCompleteUsersList');

    var template = '';
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      if (!ai.name) {
        continue;
      }
      var fileName = ai.avatar_file_name;
      if (fileName) {
        fileName = fileName.replace(/ /g, '-'); // Replace all spaces
      }
      if (
        fileName &&
        fileName.trim() !== '' &&
        fileName !== 'None' &&
        fileName !== 'null'
      ) {
        if (fileName.indexOf('static/uploads') === -1) {
          fileName = 'static/uploads/' + fileName;
        }
      } else {
        fileName = 'static/img/netwrck-logo-colord256.webp';
      }
      var displayText = ai.description ? ai.description : ai.greeting;
      var filefullURL = `https://netwrckstatic.netwrck.com/${fileName}`;
      var filefullURLEncoded = encodeURIComponent(filefullURL);
      template += `<div class="img-art-container">
<a id="mdl-editor-btn-${i}" href="https://editor.ebank.nz/index.html?imageUrl=${filefullURLEncoded}"
                       class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" title="Open in Editor">
                          <i class="material-icons">brush</i>
                    </a>
<a id="mdl-download-btn-${i}"
                       class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}" title="Download">
                          <i class="material-icons">download</i>
                    </a>
<a id="mdl-upres-btn-${i}"
                       class="mdl-editor-btn mdl-upres-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}" title="Upscale + Eye Fix">
                          <i class="material-icons">2k</i>
                    </a>
                    <a id="mdl-video-btn-${i}"
                       class="mdl-editor-btn mdl-video-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}" title="Make Video">
                          <i class="material-icons">play_arrow</i>
                    </a>
                    <a id="mdl-style-transf-btn-${i}"
                       class="mdl-editor-btn mdl-style-transf-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}" title="Style Transfer">
                          <i class="material-icons">autorenew</i>
                    </a>
                    <a id="mdl-bgremove-btn-${i}"
                       class="mdl-editor-btn mdl-bgremove-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}" title="Remove Background">
                          <i class="material-icons">content_cut</i>
                    </a>
<div class="ai-char-item mdl-cell mdl-cell--stretch mdl-cell--4-col mdl-list__item mdl-list__item--three-line">
 <a class="mdl-list__item-primary-content" href="/ai-chat/${encodeURIComponent(ai.name)}">

        <span class="mdl-chip__contact mdl-list__item-avatar">
            <img id="aiartgenerator-image${i}" class="ai-avatar-icon" src="https://netwrckstatic.netwrck.com/${fileName}" alt="${ai.name}">
            <label class="mdl-tooltip mdl-tooltip-large mdl-tooltip--top" data-mdl-for="aiartgenerator-image{{ loop.index }}">
                ${ai.name}
            </label>
        </span>

        <span class="ai-name mdl-chip__text">${ai.name}</span>

        <span class="mdl-list__item-text-body">
        ${displayText}
        </span>
    </a>

</div>
</div>`;
    }
    $target.html(template);
    componentHandler.upgradeDom();
    if (typeof adsFix === 'function') {
      adsFix();
    }
  };

  let renderAIPicsView = function (ais) {
    // Handle empty or undefined results
    if (!ais || !Array.isArray(ais)) {
      ais = [];
    }

    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      if (ai.name.startsWith('ai ')) {
        ai.name = ai.name.slice(3);
      }
    }
    dataAccessor.currentAIs = ais;

    dataAccessor.aisByName = dataAccessor.aisByName || {};
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      dataAccessor.aisByName[ai.name] = ai;
    }

    var $target = $('#autoCompleteUsersPicsList');

    var template = '';
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      if (!ai.name) {
        continue;
      }

      // Decode the name for display
      var nameDecoded = ai.name;
      try {
        nameDecoded = decodeURIComponent(ai.name);
      } catch (e) {
        console.error('Error decoding AI name:', e);
        nameDecoded = ai.name; // Fall back to original name if decoding fails
      }

      var fileName = ai.avatar_file_name;
      if (fileName) {
        fileName = fileName.replace(/ /g, '-'); // Replace all spaces
      }
      if (
        fileName &&
        fileName.trim() !== '' &&
        fileName !== 'None' &&
        fileName !== 'null'
      ) {
        if (fileName.indexOf('static/uploads') === -1) {
          fileName = 'static/uploads/' + fileName;
        }
      } else {
        fileName = 'static/img/netwrck-logo-colord256.webp';
      }
      var filefullURL = `https://netwrckstatic.netwrck.com/${fileName}`;
      var filefullURLEncoded = encodeURIComponent(filefullURL);
      var displayText = ai.description ? ai.description : ai.greeting;
      template += `<div class="ai-char-item mdl-cell mdl-cell--stretch mdl-cell--2-col mdl-list__item mdl-list__item--three-line" >
<a id="mdl-editor-btn-${i}" href="https://editor.ebank.nz/index.html?imageUrl=${filefullURLEncoded}"
                       class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank">
                          <i class="material-icons">brush</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-editor-btn-${i}">
                        Open in Editor
                    </label>
                    <a id="mdl-download-btn-${i}"
                       class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">download</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-download-btn-${i}">
                        Download
                    </label>

                    <a id="mdl-upres-btn-${i}"
                       class="mdl-editor-btn mdl-upres-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">2k</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-upres-btn-${i}">
                        Upres + Eye Fix
                    </label>
                    <a id="mdl-video-btn-${i}"
                       class="mdl-editor-btn mdl-video-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">play_arrow</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-video-btn-${i}">
                        Make Video
                    </label>
                    <a id="mdl-style-transf-btn-${i}"
                       class="mdl-editor-btn mdl-style-transf-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">autorenew</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-style-transf-btn-${i}">
                        Style Transfer
                    </label>
                    <a id="mdl-bgremove-btn-${i}"
                       class="mdl-editor-btn mdl-bgremove-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">content_cut</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-bgremove-btn-${i}">
                        Remove Background
                    </label>
 <a class="mdl-list__item-primary-content" href="/?c=${encodeURIComponent(ai.name)}">

        <span class="mdl-chip__contact mdl-list__item-avatar">
            <img id="aiartgenerator-image${i}" loading="lazy" class="jspicture${i} ai-generated-char-chooser ai-avatar-icon" src="https://netwrckstatic.netwrck.com/${fileName}" alt="${ai.name}">
            <label class="mdl-tooltip mdl-tooltip-large mdl-tooltip--top" data-mdl-for="aiartgenerator-image${i}">
                ${nameDecoded}
            </label>
        </span>
    </a>

</div>`;
    }
    $target.html(template);
    componentHandler.upgradeDom();
    if (typeof adsFix === 'function') {
      adsFix();
    }
  };

  let renderAIImagesPicsView = function (ais) {
    // Handle empty or undefined results
    if (!ais || !Array.isArray(ais)) {
      ais = [];
    }

    dataAccessor.currentAIs = ais;

    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      if (ai.name.startsWith('ai ')) {
        ai.name = ai.name.slice(3);
      }
    }

    dataAccessor.aisByName = dataAccessor.aisByName || {};
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      dataAccessor.aisByName[ai.name] = ai;
    }

    var $target = $('#autoCompleteUsersAIImagesPicsList');

    var template = '';
    for (let i = 0; i < ais.length; i++) {
      const ai = ais[i];
      if (!ai.name) {
        continue;
      }

      // Decode the name for display
      var nameDecoded = ai.name;
      try {
        nameDecoded = decodeURIComponent(ai.name);
      } catch (e) {
        console.error('Error decoding AI name:', e);
        nameDecoded = ai.name; // Fall back to original name if decoding fails
      }

      var fileName = ai.avatar_file_name;
      if (fileName) {
        fileName = fileName.replace(/ /g, '-'); // Replace all spaces
      }
      if (
        fileName &&
        fileName.trim() !== '' &&
        fileName !== 'None' &&
        fileName !== 'null'
      ) {
        if (fileName.indexOf('static/uploads') === -1) {
          fileName = 'static/uploads/' + fileName;
        }
      } else {
        fileName = 'static/img/netwrck-logo-colord256.webp';
      }

      var displayText = ai.description ? ai.description : ai.greeting;
      var filefullURL = `https://netwrckstatic.netwrck.com/${fileName}`;
      var filefullURLEncoded = encodeURIComponent(filefullURL);
      template += `<div class="ai-character-item-aiart ai-char-item mdl-cell mdl-cell--stretch mdl-cell--2-col mdl-list__item mdl-list__item--three-line" >
  <a id="mdl-editor-btn-${i}" href="https://editor.ebank.nz/index.html?imageUrl=${filefullURLEncoded}"
                       class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank">
                          <i class="material-icons">brush</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-editor-btn-${i}">
                        Open in Editor
                    </label>
                    <a id="mdl-download-btn-${i}"
                       class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">download</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-download-btn-${i}">
                        Download
                    </label>
                    <a id="mdl-upres-btn-${i}"
                       class="mdl-editor-btn mdl-upres-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">2k</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-upres-btn-${i}">
                        Upres + Eye Fix
                    </label>
                    <a id="mdl-video-btn-${i}"
                       class="mdl-editor-btn mdl-video-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">play_arrow</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-video-btn-${i}">
                        Make Video
                    </label>
                    <a id="mdl-style-transf-btn-${i}"
                       class="mdl-editor-btn mdl-style-transf-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">autorenew</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-style-transf-btn-${i}">
                        Style Transfer
                    </label>
                    <a id="mdl-bgremove-btn-${i}"
                       class="mdl-editor-btn mdl-bgremove-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="jspicture${i}">
                          <i class="material-icons">content_cut</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-bgremove-btn-${i}">
                        Remove Background
                    </label>
                    <a class="mdl-list__item-primary-content" href="aiartgenerator?c=${encodeURIComponent(ai.name)}">

        <span class="mdl-list__item-avatar-aiart mdl-chip__contact mdl-list__item-avatar">
            <img id="aiartgenerator-image${i}" loading="lazy" class="jspicture${i} ai-avatar-icon--aiart ai-generated-char-chooser ai-avatar-icon" src="https://netwrckstatic.netwrck.com/${fileName}" alt="${ai.name}">
            <label class="mdl-tooltip mdl-tooltip-large mdl-tooltip--top" data-mdl-for="aiartgenerator-image${i}">
                ${nameDecoded}
            </label>
        </span>
    </a>

</div>`;
    }
    $target.html(template);
    componentHandler.upgradeDom();
    if (typeof adsFix === 'function') adsFix();
  };

  appControllerSelf.renderAIs = $.noop;
  appControllerSelf.renderAIPics = async function ($target, searchQuery) {
    if (!(userData && userData.is_subscribed)) {
      if (subscribeImageGenCounter >= 0) {
        if (typeof window.showSubscribeDialog === 'function') {
          window.showSubscribeDialog();
          trackEvent('user', 'paywall', 'art');
        } else if (typeof window.showLoginDialog === 'function') {
          window.showLoginDialog(null, window.location.pathname);
        }
        return;
      }
    }
    try {
      $('#create-ai-find-loading-progress').show();
      var workFunc;
      if (searchQuery) {
        searchQuery = searchQuery.toLowerCase();
        workFunc = dataAccessor.searchAis(searchQuery);
      } else {
        if (dataAccessor && typeof dataAccessor.topAIs === 'function') {
          workFunc = dataAccessor.topAIs(userData && userData.secret);
        } else {
          workFunc = Promise.resolve(
            dataAccessor.initialAIs || dataAccessor.currentAIs || []
          );
        }
      }
      workFunc.then(renderAIPicsView).finally(function (err) {
        $('#create-ai-find-loading-progress').hide();
      });
      if (searchQuery) {
        searchQuery = searchQuery.toLowerCase();
        workFunc = dataAccessor.searchAiImages(searchQuery);
        workFunc.then(renderAIImagesPicsView).finally(function (err) {
          $('#create-ai-find-loading-progress').hide();
        });
      }
    } catch (e) {
      console.error(e);
    }

    var textAugmentations = [
      '',
      ' good looking fantastic',
      ' awesome portrait',
      ' confident engaging wow',
      ' stunning',
    ];
    var prefixModifiers = [
      '',
      'trending ',
      'amazing ',
      'artstation art ',
      'best quality ',
    ];

    if (window.history && window.history.pushState) {
      window.history.pushState(
        {},
        'AI Art Generator - EBank',
        '/aiartgenerator?c=' + encodeURIComponent(searchQuery)
      );
    }
    $('#createdImagePicsList').html('');
    var retries = 75;

    var styleTransferImgUrl = '';
    var $image = $('#new-ai-avatar-image img');
    if ($image.length > 0) {
      styleTransferImgUrl = $image.attr('src') || '';
    }

    var searchQueries = searchQuery.split('\n');
    searchQueries = searchQueries.map((query) => query.trim());

    searchQueries = searchQueries.filter((query) => query !== '');

    var maxIterations = Math.max(searchQueries.length, 5);
    var promises = [];

    for (var i = 0; i < maxIterations; i++) {
      var currentQuery =
        prefixModifiers[i % prefixModifiers.length] +
        searchQueries[i % searchQueries.length] +
        textAugmentations[i % textAugmentations.length];
      var urlkey = encodeURIComponent(currentQuery.split(' ').join('-'));
      if (i > 0) {
        urlkey += '-' + i;
      }
      $('.loading-progress').show();
      var shouldRetry = false;

      var creationRequest;

      if (!styleTransferImgUrl) {
        var secret = userData && userData.secret;
        if (!secret || secret === 'anonymous') {
          if (typeof window.showLoginDialog === 'function') {
            window.showLoginDialog(null, window.location.pathname);
          }
          break;
        }
        creationRequest = dataAccessor.makeRA2Image(currentQuery);
      } else {
        creationRequest = dataAccessor.makeAIStyleTransferImage(
          currentQuery,
          urlkey,
          styleTransferImgUrl
        );
      }

      var responsePromise = creationRequest
        .then(
          (function (imageIndex) {
            return function (aiJson) {
              if (!aiJson || !aiJson.path) {
                console.error(
                  'Invalid response from image generation:',
                  aiJson
                );
                throw new Error(
                  'Failed to generate image - no path in response'
                );
              }
              var aiImgUrl = aiJson['path'];
              var filefullURL = `${aiImgUrl}`;
              var filefullURLEncoded = encodeURIComponent(filefullURL);
              $('#createdImagePicsList')
                .append(`<div class="ai-char-item mdl-cell mdl-cell--stretch mdl-cell--6-col mdl-list__item mdl-list__item--three-line">
                    <a id="mdl-editor-btn-${imageIndex}" href="https://editor.ebank.nz/index.html?imageUrl=${filefullURLEncoded}"
                       class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank">
                          <i class="material-icons">brush</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-editor-btn-${imageIndex}">
                        Open in Editor
                    </label>
                    <a id="mdl-download-btn-${imageIndex}"
                       class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="madepicture${imageIndex}">
                          <i class="material-icons">download</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-download-btn-${imageIndex}">
                        Download
                    </label>
                    <a id="mdl-upres-btn-${imageIndex}"
                       class="mdl-editor-btn mdl-upres-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="madepicture${imageIndex}">
                          <i class="material-icons">2k</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-upres-btn-${imageIndex}">
                        Upres + Eye Fix
                    </label>
                    <a id="mdl-video-btn-${imageIndex}"
                    class="mdl-editor-btn mdl-video-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="madepicture${imageIndex}">
                       <i class="material-icons">play_arrow</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-video-btn-${imageIndex}">
                        Make Video
                    </label>
                    <a id="mdl-style-transf-btn-${imageIndex}"
                    class="mdl-editor-btn mdl-style-transf-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="madepicture${imageIndex}">
                       <i class="material-icons">autorenew</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-style-transf-btn-${imageIndex}">
                        Style Transfer
                    </label>
                    <a id="mdl-bgremove-btn-${imageIndex}"
                    class="mdl-editor-btn mdl-bgremove-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="madepicture${imageIndex}">
                       <i class="material-icons">content_cut</i>
                    </a>
                    <label class="mdl-tooltip" data-mdl-for="mdl-bgremove-btn-${imageIndex}">
                        Remove Background
                    </label>
                    <img loading="lazy" class="madepicture${imageIndex} b8 ai-generated-char-chooser ai-generated-char-item" src="${aiImgUrl}" alt="${searchQuery}">
                </div>`);
              shouldRetry = false;
              try {
                trackEvent('ai', 'create', 'success');
              } catch (e) {
                console.error('Error:', e);
                console.error(e);
              }
            };
          })(i)
        )
        .catch(function (err) {
          console.log(err);

          shouldRetry = true;
        });
      promises.push(responsePromise);

      if (!styleTransferImgUrl) {
        (function(query, idx) {
          var wh = dataAccessor.getWidthHeight ? dataAccessor.getWidthHeight() : { width: 512, height: 512 };
          var cw = Math.min(wh.width || 512, 1024);
          var ch = Math.min(wh.height || 512, 1024);
          dataAccessor.falFetch({
            model_name: 'comfy/leepenkman-6to13z8kkwo6/imgen',
            emptylatentimage_width: cw,
            emptylatentimage_height: ch,
            cliptextencode_text: query,
          }).then(function(r) { return r.json(); }).then(function(data) {
            var imgUrl = (data && data.result && data.result.images && data.result.images[0] && data.result.images[0].url)
              || (data && data.result && data.result.output && data.result.output.images && data.result.output.images[0])
              || null;
            if (!imgUrl) return;
            var encoded = encodeURIComponent(imgUrl);
            $('#createdImagePicsList').append('<div class="ai-char-item mdl-cell mdl-cell--stretch mdl-cell--6-col mdl-list__item"><a href="https://editor.ebank.nz/index.html?imageUrl=' + encoded + '" class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank"><i class="material-icons">brush</i></a><img loading="lazy" class="b8 ai-generated-char-item" src="' + imgUrl + '" alt="' + query + '"></div>');
          }).catch(function() {});
        })(currentQuery, i);
      }

      if (styleTransferImgUrl) {
        await responsePromise;
      }

      if (!styleTransferImgUrl) {
        shouldRetry = false;
      }
      if (shouldRetry) {
        if (retries > 0) {
          i--;
          retries--;
        }
        trackEvent('ai', 'create', 'fail');
      } else {
        subscribeImageGenCounter++;
        setCookie('subscribeImageGenCounter', subscribeImageGenCounter, 365);
      }
    }
    await Promise.all(promises);
    $('.loading-progress').hide();
  };
  appControllerSelf.writeNewAItoLocationFunc = function (name, imgUrl) {
    function extractObjectPath(urlOrPath) {
      try {
        if (!urlOrPath) return '';
        var s = String(urlOrPath).trim();
        if (s.startsWith('static/uploads/')) return s;
        if (s.startsWith('uploads/')) return 'static/uploads/' + s.slice('uploads/'.length);
        var idx = s.indexOf('static/uploads/');
        if (idx >= 0) return s.slice(idx);
        var idx2 = s.indexOf('/uploads/');
        if (idx2 >= 0) return 'static/uploads/' + s.slice(idx2 + '/uploads/'.length);
        var last = s.split('/').pop();
        if (last && last.indexOf('.') > 0) return 'static/uploads/' + last;
        return s;
      } catch (_) { return String(urlOrPath || ''); }
    }

    var fileName = extractObjectPath(imgUrl);

    $('#add-new-ai-form input[name="newaiavatarurl"]').val(fileName);
    $('#new-ai-avatar-image').html(
      `<img src="https://netwrckstatic.netwrck.com/${fileName}" width="81" height="81"/>`
    );
  };
  appControllerSelf.writeNewAItoLocationCharacterDesignFunc =
    appControllerSelf.writeNewAItoLocationFunc;
  appControllerSelf.writeNewAItoLocationChatFunc = function (name, imgUrl) {
    var fileName = (function(){
      try{ return extractObjectPath(imgUrl); }catch(_){ return imgUrl; }
    })();
    var aiImgUrl = 'https://netwrckstatic.netwrck.com/' + fileName;

    let currentVal = $('.question-text').val();
    var isFinishingSpace = currentVal[currentVal.length - 1] === ' ';
    let textToWrite = `a ${name} appears`;

    if (!isFinishingSpace && currentVal[currentVal.length - 1]) {
      textToWrite = ' ' + textToWrite;
    }

    $('.question-text').focus();
    var input = $('.question-text')[0];
    input.selectionStart = input.selectionEnd = input.value.length;
    safeSendKeys($('.question-text'), textToWrite);
  };
  dataAccessor.aisByName = dataAccessor.aisByName || {};
  $(document).on('click', '.ai-generated-char-chooser', function (event) {
    var $self = $(this);
    var aiImgUrl = $self.attr('src');
    var aiName = $self.attr('alt');
    appControllerSelf.writeNewAItoLocationFunc(aiName, aiImgUrl);

    var dialog = document.getElementById('create-pic-dialog');

    dialog?.close();
  });

  $(document).on('click', '#autoCompleteUsersList a', function (event) {
    const $self = $(this);
    currentName = $self.find('.ai-name').text();
    currentAI = dataAccessor.aisByName[currentName];

    if (currentAI) {
      fixtures.currentAI = currentAI;
      ReRenderCurrentGame();
      var avatarFileName = fixtures.currentAI.avatar_file_name;

      if (avatarFileName && avatarFileName !== 'None') {
        if (avatarFileName) {
          avatarFileName = avatarFileName.replace(' ', '-');
        }
        avatarFileName = avatarFileName.trim();
        if (avatarFileName.indexOf('static/uploads') === -1) {
          avatarFileName = 'static/uploads/' + avatarFileName;
        }
        $('.chat-one-to-one-icon').attr(
          'src',
          'https://netwrckstatic.netwrck.com/' + avatarFileName
        );
      } else {
        $('.chat-one-to-one-icon').attr(
          'src',
          'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp'
        );
      }
      $('.chat-one-to-one-name').text(fixtures.currentAI?.name);

      $('.chat-one-to-one-name-tooltip').text(fixtures.currentAI.description);

      $('#add-chat-dialog')[0].close();
    }
  });
  return appControllerSelf;
})();

let nagDialog = function () {
  var $dialog = $('#subscribe-dialog');
  if (userData && userData.is_subscribed) {
    return;
  }
  if ($dialog.length) {
    $dialog[0].close();
    $dialog[0].showModal();
  }
};

let icoDialog = function () {
  var $dialog = $('#ico-dialog');
  if ($dialog.length) {
    $dialog[0].close();
    $dialog[0].showModal();
  }
};

// Removed timed subscription nag to avoid unsolicited popups
// (manual triggers remain via explicit user actions)

$(document).ready(function () {
  window.setTimeout(function () {
    var isAndroid = /(android)/i.test(navigator.userAgent);
    if (isAndroid) {
      $('.android-hide').hide();

      var styleTag = document.createElement('style');
      styleTag.innerHTML = '.android-hide { display: none; }';
      document.head.appendChild(styleTag);
    }
  }, 1000);
});

backgroundChangeNum = 1;
function setBackground(bgImageName) {
  var $oldEl = $('.backdrop-ai-' + backgroundChangeNum);

  if (backgroundChangeNum === 1) {
    backgroundChangeNum = 2;
  } else {
    backgroundChangeNum = 1;
  }

  let $elToChange = $('.backdrop-ai-' + backgroundChangeNum);

  $elToChange.css('background', $oldEl.css('background'));
  $elToChange.css({ display: 'block', opacity: 0 });
  $oldEl.css({ display: 'block', opacity: 1 });
  window.setTimeout(function () {
    elToChange.style.transition = 'opacity 0.5s ease-in-out';
    elToChange.style.background =
      'url(' + bgImageName + ') no-repeat center center fixed';
    elToChange.style.backgroundSize = 'cover';
    elToChange.style.opacity = '1';
    $oldEl.css('opacity', 0);

    window.setTimeout(function () {
      $oldEl.css('background', $elToChange.css('background'));
      $oldEl.css('opacity', 1);
    }, 500);
  }, 1);
  var elToChange = $elToChange[0];
}

function preloadImage(imageName, onload) {
  if (window.ImageUtils && window.ImageUtils.preloadImage) {
    return window.ImageUtils.preloadImage(imageName, onload);
  } else {
    // Fallback implementation if ImageUtils is not loaded
    var img = new Image();
    img.onload = onload || function () {};
    img.onerror = onload || function () {};
    img.src = imageName;
    return img;
  }
}

$(document).ready(function () {
  var flex = document.getElementsByClassName('mdl-layout__container')[0];
  if (flex && !(document.documentElement.classList.contains('ebank-site') || /(^|\.)ebank\./.test(window.location.hostname))) {
    const observer = new MutationObserver(function (mutations, observer) {
      flex.style.height = '';
    });
    observer.observe(flex, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  window.updateHeaderAuthState();

  window.addEventListener('authStateChanged', function () {
    window.updateHeaderAuthState();
  });

  // Infinite scroll functionality for AI images
  var infiniteScrollState = {
    isEnabled: false,
    isLoading: false,
    hasMoreContent: true,
    lastQuery: '',
    nextPage: 1,
    scrollThreshold: 400,
    autoLoadCount: 0,
    maxAutoLoads: 20,
  };

  function enableInfiniteScroll(initialQuery) {
    console.log('Enabling infinite scroll for AI images');
    infiniteScrollState.isEnabled = true;
    infiniteScrollState.lastQuery =
      initialQuery || $('.searchboxaisprompt').val() || '';
    infiniteScrollState.nextPage = 1;
    infiniteScrollState.hasMoreContent = true;
    infiniteScrollState.autoLoadCount = 0;

    $(window)
      .off('scroll.infiniteScroll')
      .on('scroll.infiniteScroll', handleInfiniteScroll);

    setTimeout(checkAndAutoLoad, 500);
  }

  function checkAndAutoLoad() {
    if (!infiniteScrollState.isEnabled || infiniteScrollState.isLoading) {
      return;
    }

    var $aiImagesContainer = $(
      '#autoCompleteUsersAIImagesPicsList, #dynamic-ai-art-results, .ai-images-container'
    ).first();
    if (!$aiImagesContainer.length) {
      return;
    }

    var containerHeight = $aiImagesContainer.outerHeight();
    var windowHeight = $(window).height();
    var hasEnoughContent = containerHeight > windowHeight * 2.2;

    if (
      !hasEnoughContent &&
      infiniteScrollState.hasMoreContent &&
      infiniteScrollState.autoLoadCount < infiniteScrollState.maxAutoLoads
    ) {
      console.log('Auto-loading more content - not enough on screen');
      loadMoreAIImagesInfiniteScroll();
    }
  }

  function disableInfiniteScroll() {
    infiniteScrollState.isEnabled = false;
    $(window).off('scroll.infiniteScroll');
    $('#infinite-scroll-loading').remove();
  }

  // Cleanup infinite scroll when window is unloaded
  $(window).on('beforeunload', disableInfiniteScroll);

  // Export functions to window for testing and external access
  window.infiniteScrollFunctions = {
    enableInfiniteScroll: enableInfiniteScroll,
    disableInfiniteScroll: disableInfiniteScroll,
    checkAndAutoLoad: checkAndAutoLoad,
    loadMoreAIImagesInfiniteScroll: loadMoreAIImagesInfiniteScroll,
    infiniteScrollState: infiniteScrollState,
  };

  function handleInfiniteScroll() {
    if (
      !infiniteScrollState.isEnabled ||
      infiniteScrollState.isLoading ||
      !infiniteScrollState.hasMoreContent
    ) {
      return;
    }

    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var documentHeight = $(document).height();
    var scrollPercentage = (scrollTop + windowHeight) / documentHeight;
    var distanceFromBottom = documentHeight - (scrollTop + windowHeight);

    // Debug logging
    if (window.DEBUG_INFINITE_SCROLL) {
      console.log('Scroll state:', {
        scrollTop: scrollTop,
        windowHeight: windowHeight,
        documentHeight: documentHeight,
        scrollPercentage: scrollPercentage,
        distanceFromBottom: distanceFromBottom,
        threshold: infiniteScrollState.scrollThreshold,
      });
    }

    // Trigger when close to bottom
    if (
      distanceFromBottom < infiniteScrollState.scrollThreshold ||
      scrollPercentage > 0.85
    ) {
      console.log('Infinite scroll triggered - loading more AI images');
      infiniteScrollState.autoLoadCount++;
      loadMoreAIImagesInfiniteScroll();
    }
  }

  function loadMoreAIImagesInfiniteScroll() {
    var currentQuery = $('.searchboxaisprompt').val();

    if (!currentQuery || infiniteScrollState.isLoading) {
      return;
    }

    infiniteScrollState.isLoading = true;

    // Show subtle loading indicator
    var $loadingIndicator = $('#infinite-scroll-loading');
    if (!$loadingIndicator.length) {
      $loadingIndicator = $(
        '<div id="infinite-scroll-loading" style="text-align: center; padding: 20px; opacity: 0.7;">' +
          '<span class="mdl-spinner mdl-js-spinner is-active"></span>' +
          '<p style="margin-top: 10px;">Loading more...</p>' +
          '</div>'
      );
      $('.ai-images-container, #autoCompleteUsersAIImagesPicsList').after($loadingIndicator);
      componentHandler.upgradeElement(
        $loadingIndicator.find('.mdl-spinner')[0]
      );
    }
    $loadingIndicator.show();

    var nextOffset = infiniteScrollState.nextPage * 80;

    $.ajax({
      url: '/api/search-aiimages',
      type: 'GET',
      data: {
        query: currentQuery,
        offset: nextOffset,
        limit: 80,
      },
      success: function (response) {
        var images = Array.isArray(response)
          ? response
          : (response && response.ai_images) || [];
        if (images.length > 0) {
          appendNewAIImages(images);
          infiniteScrollState.nextPage++;

          if (images.length < 80) {
            infiniteScrollState.hasMoreContent = false;
            $loadingIndicator.html(
              '<p style="opacity: 0.5;">No more results</p>'
            );
            setTimeout(function () {
              $loadingIndicator.fadeOut();
            }, 2000);
          }

          setTimeout(checkAndAutoLoad, 500);
        } else {
          infiniteScrollState.hasMoreContent = false;
          $loadingIndicator.html(
            '<p style="opacity: 0.5;">No more results</p>'
          );
          setTimeout(function () {
            $loadingIndicator.fadeOut();
          }, 2000);
        }
      },
      error: function (xhr, status, error) {
        console.error('Error loading more AI images:', error);
        $loadingIndicator.html(
          '<p style="color: #f44336;">Error loading more content. Please try again.</p>'
        );
        setTimeout(function () {
          $loadingIndicator.fadeOut();
        }, 3000);
      },
      complete: function () {
        infiniteScrollState.isLoading = false;
        if (infiniteScrollState.hasMoreContent) {
          $loadingIndicator.fadeOut();
        }
      },
    });
  }

  function appendNewAIImages(aiImages) {
    var $container = $(
      '#autoCompleteUsersAIImagesPicsList, #dynamic-ai-art-results, .ai-images-container'
    ).first();

    aiImages.forEach(function (image) {
      if (!image.url) {
        var fileName = image.avatar_file_name || image.AvatarFileName || '';
        if (fileName && fileName.indexOf('static/uploads') === -1) {
          fileName = 'static/uploads/' + fileName;
        }
        if (fileName) {
          image.url = 'https://netwrckstatic.netwrck.com/' + fileName;
        }
      }
      if (!image.title) {
        image.title = image.name || image.Name || 'art';
      }
      var imageCard = createAIImageCard(image);
      $container.append(imageCard);
    });

    // Upgrade any MDL components in the new content
    if (typeof componentHandler !== 'undefined') {
      componentHandler.upgradeDom();
    }
  }

  function createAIImageCard(image) {
    // Generate unique ID for this image card
    var uniqueId =
      'ai-generated-image-' + Date.now() + Math.floor(Math.random() * 1000);

    var cardHtml =
      '<div class="ai-char-item mdl-cell mdl-cell--stretch mdl-cell--6-col mdl-list__item mdl-list__item--three-line">' +
      '<a id="mdl-editor-btn-' +
      uniqueId +
      '" href="https://editor.ebank.nz/index.html?imageUrl=' +
      encodeURIComponent(image.url) +
      '" class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank">' +
      '<i class="material-icons">brush</i>' +
      '</a>' +
      '<label class="mdl-tooltip" data-mdl-for="mdl-editor-btn-' +
      uniqueId +
      '">' +
      'Open in Editor' +
      '</label>' +
      '<a id="mdl-download-btn-' +
      uniqueId +
      '" class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="' +
      uniqueId +
      '">' +
      '<i class="material-icons">download</i>' +
      '</a>' +
      '<label class="mdl-tooltip" data-mdl-for="mdl-download-btn-' +
      uniqueId +
      '">' +
      'Download' +
      '</label>' +
      '<a id="mdl-upres-btn-' +
      uniqueId +
      '" class="mdl-editor-btn mdl-upres-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="' +
      uniqueId +
      '">' +
      '<i class="material-icons">2k</i>' +
      '</a>' +
      '<label class="mdl-tooltip" data-mdl-for="mdl-upres-btn-' +
      uniqueId +
      '">' +
      'Upres + Eye Fix' +
      '</label>' +
      '<a id="mdl-video-btn-' +
      uniqueId +
      '" class="mdl-editor-btn mdl-video-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="' +
      uniqueId +
      '">' +
      '<i class="material-icons">play_arrow</i>' +
      '</a>' +
      '<label class="mdl-tooltip" data-mdl-for="mdl-video-btn-' +
      uniqueId +
      '">' +
      'Make Video' +
      '</label>' +
      '<a id="mdl-style-transf-btn-' +
      uniqueId +
      '" class="mdl-editor-btn mdl-style-transf-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="' +
      uniqueId +
      '">' +
      '<i class="material-icons">autorenew</i>' +
      '</a>' +
      '<label class="mdl-tooltip" data-mdl-for="mdl-style-transf-btn-' +
      uniqueId +
      '">' +
      'Style Transfer' +
      '</label>' +
      '<a id="mdl-bgremove-btn-' +
      uniqueId +
      '" class="mdl-editor-btn mdl-bgremove-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="' +
      uniqueId +
      '">' +
      '<i class="material-icons">content_cut</i>' +
      '</a>' +
      '<label class="mdl-tooltip" data-mdl-for="mdl-bgremove-btn-' +
      uniqueId +
      '">' +
      'Remove Background' +
      '</label>' +
      '<img loading="lazy" class="' +
      uniqueId +
      ' b8 ai-generated-char-chooser ai-generated-char-item" src="' +
      image.url +
      '" alt="' +
      (image.title || 'art') +
      '">' +
      '</div>';

    return cardHtml;
  }

  // Initialize infinite scroll if on AI images page
  $(document).ready(function () {
    if (
      ($('#autoCompleteUsersAIImagesPicsList').length ||
        $('.ai-images-container').length) &&
      $('.searchboxaisprompt').val()
    ) {
      enableInfiniteScroll();
    }
  });

  // Re-enable infinite scroll when search is performed
  $(document).on('submit', '.search-form', function () {
    var query = $('.searchboxaisprompt').val();
    if (query) {
      setTimeout(function () {
        enableInfiniteScroll(query);
      }, 1000);
    }
  });
});
